export const questions = {
    "quizTitle": "RND – Regulamentul de navigație pe Dunăre și canal",
    "quizSynopsis": "Examen RND · 30 întrebări · 30 min · minim 24 corecte",
    "progressBarColor": "#9de1f6",
    "nrOfQuestions": "501",
    "examConfig": {
        "personnelCategory": "CLASA A",
        "timeMinutes": 30,
        "passPercent": 80,
        "minCorrect": 24,
        "barem": 8,
        "modelName": "Examen RND",
        "sections": [
            {
                "id": "RND-S1",
                "label": "RND · Generalități",
                "count": 4,
                "difficulty": 1
            },
            {
                "id": "RND-S2",
                "label": "RND · Lumini și semnalizare",
                "count": 7,
                "difficulty": 1
            },
            {
                "id": "RND-S3",
                "label": "RND · Semnale și semne de navigație",
                "count": 8,
                "difficulty": 1
            },
            {
                "id": "RND-S4",
                "label": "RND · Manevră și semnale sonore",
                "count": 8,
                "difficulty": 1
            },
            {
                "id": "RND-S5",
                "label": "RND · Canalul Sulina",
                "count": 3,
                "difficulty": 1
            }
        ],
        "totalQuestions": 30
    },
    "appLocale": {
        "landingHeaderText": "<questionLength> Intrebari",
        "question": "Intrebare",
        "startQuizBtn": "Incepe",
        "resultFilterAll": "Toate",
        "resultFilterCorrect": "Correct",
        "resultFilterIncorrect": "Incorect",
        "prevQuestionBtn": "Inapoi",
        "nextQuestionBtn": "Inainte",
        "multipleSelectionTagText": "Selectie multipla",
        "resultPageHeaderText": "Ai terminat. Ai <correctIndexLength> raspunsuri corecte din <questionLength> total.",
        "pickNumberOfSelection": "Alege <numberOfSelection>",
        "marksOfQuestion": "(<marks> puncte)"
    },
    "questions": [
        {
            "question": "1. Ce se înţelege prin \"material plutitor asamblat\" în sensul regulamentului de navigaţie ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Piese din lemn destinate transportului pe o cale navigabilă.",
                "b) Plutele, precum şi orice construcţie, grupări sau orice obiecte apte de a naviga, altele decât nave sau instalaţii plutitoare.",
                "c) O asamblare a buştenilor, destinată transportului pe o cale navigabilă."
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "2. De la ce dinstanţe aproximative trebuie să fie văzută o limină obişnuită albă în condiţii de vizibilitate normală ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 1,7-3,2 km",
                "b) 2,3-3,0 km",
                "c) 1,6-2,5 km"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "3. Intervalul între sunetele care compun \"o serie de sunete foarte scurte\" este de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) circa ½ s",
                "b) circa 1 s",
                "c) circa ¼ s"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "4. Pentru a evita un pericol iminent, conducătorii trebuie să ia toate măsurile cerute de împrejurări, chiar dacă se îndepărtează de la dispoziţiile R.N.D.",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Numai pentru a salva nava"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "5. În caz de accident care pune în pericol persoanele care se găsesc la bord, conducătorul trebuie :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să anunţe prin orice mijloace Căpitănia portului cea mai apropiată pentru salvarea persoanelor",
                "b) Să se folosească de toate mijloacele care sunt la dispoziţia lui pentru salvarea acestor persoane",
                "c) Să ceară ajutor navelor care navigă în apropiere"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "6. Ce se înţelege prin \"convoi împins\" în sensul R.N.D. ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un ansamblu compus din nave, instalaţii plutitoare, plute sau alte construcţii plutitoare, cuplate bord la bord şi având cel puţin o navă autopropulsată",
                "b) Un ansamblu compus din nave dintre care cel puţin una este plasată înaintea navei autopropulsate",
                "c) un ansamblu rigid compus din nave, din care cel puţin una este plasată înaintea navei autopropulsate care asigură propulsia convoiului şi care este denumită împingător"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "7. Ce se înţelege prin termenul \"zi\" întrebuinţat în R.N.D ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Perioada cuprinsă între apusul şi răsăritul soarelui",
                "b) Nu este prevăzut în R.N.D.",
                "c) Perioada cuprinsă între răsăritul şi apusul soarelui"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "8. De la ce dinstanţe aproximative trebuie să fie văzută o lumină albastră obişnuită, în condiţii de vizibilitate normală ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 2,3-3,0 km",
                "b) 1,7-3,2 km",
                "c) 1,0-1,3 km"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "9. În cazul unui convoi remorcat ce are în faţă mai multe nave autopropulsate în linie de şir, cine este munit conducătorul convoiului ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Conducătorul primei nave autopropulsate",
                "b) Conducătorul navei autopropulsate cu puterea cea mai mare",
                "c) Nava autopropulsată ce are parâmele de remorcă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "10. Orice navă nepropulsată cu echipaj la bord, destinată transportului de mărfuri, cu excepţia navelor maritime, ambarcaţiunilor mici şi ambarcaţiunilor de agrement, trebui conform R.N.D. să aibă la bord următoarele acte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Atestat de bord, certificat de tonaj, rol de echipaj, jurnalul de maşini, jurnalul de bord",
                "b) Atestat de bord certificat de tonaj, registru de scară, jurnalul de bord",
                "c) Atestat de bord, certificat de tonaj, rol de echipaj alete documente referitoare la navigaţie, care sunt cerute în virtutea convenţiilor sau acordurilor internaţionale"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "11. Toate navele fluviale trebuie să aibă mărci care indică linia maximă de încărcare ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da exclusiv micile ambarcaţiuni",
                "b) Da inclusiv micile ambarcaţiuni",
                "c) Nu este prevăzut expres în R.N.D"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "12. Ce se înţelege prin \"instalaţie plutitoare\" în sensul R.N.D. ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Construcţie plutitoare, dotată cu instalaţii mecanice şi destinată lucrărilor speciale pe calea navigabilă sau în porturi (drăgi, elevatoare, bigi, macarale)",
                "b) Navele de navigaţie interioară, inclusiv ambarcaţiunile mici şi bacurile",
                "c) Construcţiile plutitoare care, în mod normal, nu sunt destinate deplasării sau efectuării lucrărilor speciale pe calea navigabilă ca : instalaţii de băi, docuri, debarcadere şi hangare pentru nave"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "13. De la ce distanţă aproximativă trebui să fie văzută o lumină clară roşie, în condiţii de vizibilitate normală ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 2,5-5,0 km",
                "b) 2,8-5,3 km",
                "c) 2,8-5,0 km"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "14. Durata unui sunet lung este de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Circa 5 secunde",
                "b) Circa 6 secunde",
                "c) Circa 4 secunde"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "15. Conducătorii navelor remorcate trebuie să se conformeze ordinelor conducătorului convoiului ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Numai în cazuri speciale"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "16. În cazul cînd o navă pierde un obiect sau poate crea un obstacol sau un pericol pentru navigaţie, conducătorul navei este obligat :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să consemneze în jurnalul de bord, îndicând, pe cât posibil, locul şi dacă este posibil, să marcheze acel loc cu un reper, după care depune un raport la căpitănia portului de destinaţie",
                "b) Să anunţe fără întârziere căpitănia portului cea mai apropiată, indicând pe cât posibil, locul unde a fost pierdut obiectul şi, pe măsura posibilităţilor, să marcheze acel loc cu un reper",
                "c) Să ia măsuri imediate pentru scoaterea obiectului pierdut, anuntând întreprinderea de care aparţine nava asupra măsurilor luate"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "17. \"Bordul liber\" este :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Distanţa dinte linia de încărcare maximă şi pescajul navei",
                "b) Distanţa dintre linia de încărcare maximă şi lina de încărcare minimă",
                "c) Distanţa măsurată între planul de încărcare maximă şi suprafaţa punţii superioare în punctul ei cel mai de jos, sau în lipsa punţii, punctul cel mai jos al părţii superioare a bordului fix"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "18. Ce se înţelege prin \"navă\" în sensul R.N.D. ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Mijlocul de navigaţie utilizat pentru realizarea activităţii de transport şi a altor servicii pe apă",
                "b) Navele de navigaţie interioară, inclusiv ambarcaţiunile mici şi bacurile, precum şi aparatele plutitoare şi navele maritime",
                "c) Navele maritime, fluviale, aparatele plutitoare, plute, nave militare etc"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "19. Ce se înţelege ărin termenul de \"în staţionare\" folosit în R.N.D. ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O navă, atunci când este legată la mal",
                "b) O navă sau un material plutitor asamblat când este legată la mal",
                "c) O navă, un material plutitor asamblat sau o instalaţie plutitoare atunci când este, în mod direct sau indirect ancorată sau legată la mal"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "20. De la ce dinstanţe aproximative trebui să fie văzută o lumină obişnuită verde, în condiţii de vizibilitate normală ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 1,6-2,5 km",
                "b) 1,7-3,2 km",
                "c) 1,0-2,3 km"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "21. Cine este conducătorul unui convoi sau a unei formaţii în cuplu care cuprind o singură navă autopropulsată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Conducătorul navei nepropulsate",
                "b) Nu este prevăzut în R.N.D.",
                "c) Conducătorul navei autopropulsate"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "22. Orice ambarcaţiune mică (în sensul R.N.D.) autopropulsată, nedestinată transporturilor de mărfuri cu excepţia ambarcaţiunilor de agrement, trebui, conform R.N.D. să aibă la bord următoarele documente :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Carnet de ambarcaţiune, registrul de schelă",
                "b) Atestatul de bord, certificatul de tonaj",
                "c) Atestatul de bord, rolul de echipaj"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "23. \"Distanţa de siguranţă\" este :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Distanţa dintre linia de încărcare maximă şi punctul cel mai de sus, deasupra căruia nava nu mai este etanşă",
                "b) Distanţa dintre linia de încărcare maximă şi planul de plutire al navei goale",
                "c) Distanţa dintre planul de încărcare maximă şi punctul cel mai de jos, deasupra căruia nava nu mai este considerată ca etanşă, fără a ţine cont de alimentări şi evacuări de apă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "24. Ce se înţelege prin bac \"în sensul R.N.D.\" ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava care asigură serviciul de traversare a căii navigabile şi care este clasificată ca bac de către organele competente",
                "b) Nave care au capacitate de încărcare până la 100 T",
                "c) Nave autopropulsate care asigură serviciul de traversare a căii navigabile"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "25. De la ce distanţe aproximative trebui să fie văzută o lumină clară verde, în condiţii de vizibilitate normală.",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 2,8-5,0 km",
                "b) 2,8-5,3 km",
                "c) 2,9-5,0 km"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "26. Intervalul între două sunete consecutive este de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Circa 1 secundă",
                "b) Circa ½ secunde",
                "c) Circa ¼ secunde"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "27. Care sunt îndatoririle altor persoane care se găsesc la bordul navei :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să se supună dispoziţiilor conducătorului navei, în interesul siguranţei navigaţiei şi ordinii la bord",
                "b) Să se supună dispoziţiilor conducătorului navei, numai la ambarcarea şi debarcarea lor",
                "c) Nu este prevăzut expres în R.N.D"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "28. Orice conducător de navă, dacă constată avarierea unei instalaţii de semnalizare (stingerea unei lumini, deplasarea unei geamanduri, distrugerea unui semnal, etc.) este obligat :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să ia măsuri imediate de remediere a semnalului avariat",
                "b) Să anunţe fără întârziere căpitănia de port cea mai apropiată asupra avarierii instalaţiei de semnalizare respectivă",
                "c) Să anunţe prin orice mijloc întreprinderea care are în administraţie întreţinerea şi semnalizarea căii navigabile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "29. Ancorele navelor fluviale trebui să poarte mărci de identificare :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da, cu excepţia ambarcaţiunilor mici",
                "b) Nu",
                "c) Nu este prevăzut expres în R.N.D"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "30. Ce se înţelege prin \"convoi remorcat\" în sensul R.N.D. ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un grup de nave din care una autopropulsată",
                "b) Un grup de nave toate autopropulsate",
                "c) Orice grup compus din una sau mai multe nave, instalaţii plutitoare sau materiale plutitoare asamblate care sunt remorcate de una sau mai multe nave autopropulsate care fac parte din convoi şi se numesc remorchere"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "31. Ce se înţelege prin \"marş\" în sensul R.N.D. :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Când o navă, un material plutitor asamblat sau o instalaţie plutitoare, nu este direct, nici în ancoră, nici legată la mal şi nici eşuată",
                "b) O navă atunci când navigă chiar şi în derivă",
                "c) O navă când nu este ancorată sau legată"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "32. De la ce distanţe aproximative trebui să fie văzută o lumină obişnuită galbenă în condiţii de vizibilitate normală ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 1,6-2,5 km",
                "b) 1,7-3,2 km",
                "c) 2,4-2,8 km"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "33. Convoaiele sunt puse sub autoritatea unui conducător ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu",
                "b) Da",
                "c) Nu este prevăzut expres în R.N.D"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "34. Navele de pasageri pot transporta un număr de pasageri corespunzător :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Planurilor de construcţie ale navei",
                "b) Instrucţiunilor şantierului constructor",
                "c) Autorizaţiei organelor competente"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "35. Fiecare navă destinată transporturilor de mărfuri, cu excepţia ambarcaţiunilor mici şi a navelor maritime, trebuie conform Regulamentului de navigaţie pe Dunăre, să poarte pe corp sau pe panouri fixate definitiv, următoarele mărci de identificare :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Numele (numărul); portul de ataş sau locul de înmatriculare urmat de litera sau literele care indică ţara unde se găseşte acest port sau loc de înmatriculare; indicaţia în tone a capacităţii de încărcare şi numele (prescurtarea sa obişnuită) proprietarului sau al organizaţiei căreia aparţine nava",
                "b) Numele (numărul); portul de înmatriculare, numele (prescurtarea sa obişnuită) proprietarul sau organizaţiei căreia aparţine nava",
                "c) Numele (numărul) portul de ataş; capacitatea netă în tone; iniţialele întreprinderii sau organizaţiei de care aparţine nava"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "36. Ce se înţelege prin “navă autopropulsată” în sensul R.N.D ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava propulsată prin propriile sale mijloace mecanice",
                "b) Orice navă propulsată cu orice fel de mijloace",
                "c) Orice navă care se deplasează pe apă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "37. Ce se înţelege prin termenul de “noapte” în sensul R.N.D. ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Perioada cuprinsă între răsăritul şi apusul soarelui",
                "b) Perioada cuprinsă între apusul şi răsăritul soarelui",
                "c) Nu este prevăzut în R.N.D"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "38. De la ce distanţa aproximativă trebuie să fie văzută o lumină obişnuită roşie, în condiţii de vizibilitate normală ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 1,6-2,5 km",
                "b) 1,7-3,2 km",
                "c) 1,0-2,3 km"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "39. Ce nave trebuie puse sub autoritatea unui conducător sau comandant ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Orice navă, cu excepţia navelor dintr-un convoi împins în afara de împingător",
                "b) Orice navă",
                "c) Numai navele autopropulsate"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "40. Orice navă autopropulsată, nedestinată transporturilor de mărfuri, cu excepţia navelor maritime, ambarcaţiunilor mici şi ambarcaţiunilor de agrement, trebuie conform R.N.D în sectorul românesc să aibă la bord următoarele documente :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Atestat de bord; registru de schelă; jurnal de bord; jurnal de maşină",
                "b) Atestat de bord; rolul de echipaj; jurnalul de bord; alte documente referitoare la navigaţie, care sunt cerute în virtutea convenţiilor sau acordurilor internaţionale",
                "c) Atestat de bord; certificat de tonaj; rolul de echipaj; jurnal de bord; jurnal de maşini"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "41. Fiecare navă destinată transportului de pasageri, cu excepţia ambarcaţiunilor mici şi a navelor maritime, trebuie conform R.N.D. în sectorul românesc să poarte pe corp sau pe panouri fixate definitiv, următoarele mărci de identificare :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Numele sau deviza, portul de ataş sau locul de înmatriculare, urmat de litera sau literele care indică ţara unde se găseşte acest port, indicaţia numărului maxim de pasageri autorizat, numele proprietarului, (prescurtarea sa obişnuită) sau al organizaţiei de care aparţine nava",
                "b) Numele (numărul) navei, portul de înmatriculare, numele sau iniţialele proprietarului, indicaţia în tone a capacităţii sale brute",
                "c) Numele (numărul) navei, portul de ataş sau locul de înmatriculare, capacitatea în tone şi numărul minim de pasageri admis, numele sau iniţialele proprietarului căruia îi aparţine nava"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "42. Ce este o “formaţie în cuplu” în sensul Regulamentului de Navigaţie pe Dunăre ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un ansamblu compus din nave cuplate bord la bord dar nici una din ele nu este plasată în faţa navei autopropulsate care asigură propulsia formaţiei",
                "b) Un ansamblu compus din nave la care cel puţin una este plasată înaintea navei autopropulsate care asigură propulsia cuplului",
                "c) Un ansamblu compus din nave, instalaţii plutitoare, plute sau alte construcţii plutitoare aflate bord la bord"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "43. De la ce distanţă aproximativă trebuie să fie văzută o lumină puternică albă în condiţii de vizibilitate normală ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 5,9-6,5 km",
                "b) 5,8-6,5 km",
                "c) 5,9-6 km"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "44. Ce se înţelege prin lumină intermitentă ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină cu un ritm de la 40 la 60 perioade de lumini pe minut",
                "b) O lumină cu ritm de la 45 la 60 perioade de lumini pe minut",
                "c) O lumină cu un ritm de 50 până la 60 perioade de lumini pe minut"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "45. Cine este conducătorul convoiului ce are în faţă două sau mai multe nave autopropulsate ce navigă în cuplu ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Conducătorul navei autopropulsate cu puterea cea mai mare",
                "b) Conducătorul navei autopropulsate ce are parâmele de remorcă",
                "c) Conducătorul navei autopropulsate cu vechimea cea mai mare în funcţie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "46. Navele pot fi încărcate ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Peste linia de încărcare care corespunde liniei inferioare a mărcilor de încărcare",
                "b) Până la limita inferioară a liniei de încărcare maximă corespunzătoare mărcilor de încărcare",
                "c) Până la limita superioară a liniei de încărcare maximă corespunzătoare mărcii de încărcare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "47. Linia de încărcare maximă este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Linia care materializează încărcarea navei",
                "b) Linia de plutire care corespunde afundării maxime la care nava poate să navige",
                "c) Linia care corespunde capacităţii nete de încărcare a navelor"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "48. Ce se înţelege prin aparat plutitor în sensul Regulamentului de Navigaţie pe Dunăre ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Construcţie plutitoare care în mod normal nu este destinată deplasării sau efectuării lucrărilor speciale pe calea navigabilă ca: instalaţie de băi, docuri, debarcadere şi hangare pentru nave",
                "b) Construcţie plutitoare dotată cu instalaţii mecanice şi destinată să execute lucrări pe căile navigabile sau în porturi (drăgi, macarale, elevatoare, bigi, etc)",
                "c) Navele de navigaţie interioară inclusiv ambarcaţiunile mici şi bacurile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "49. De la ce distanţă aproximativă trebuie să fie văzută o lumină albă clară în condiţii de vizibilitate normală ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 3,9-5,9 km",
                "b) 3,9-5,3 km",
                "c) 3,8-5,0 km"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "50. Durata unui sunet scurt este de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Circa o jumătate de secundă",
                "b) Circa 1 secundă",
                "c) Circa ¼ secundă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "51. Conducătorul unui aparat plutitor trebuie să fie întotdeauna la bord în timp ce aparatul este în lucru ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Nu este prevăzut în Regulament"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "52. Orice ambarcaţiune mică nepropulsată cu echipaj la bord destinată transportului de mărfuri cu excepţia ambarcaţiunii de agrement trebuie, conform R.N.D în sectorul românesc, să aibă la bord următoarele documente :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Carnetul de ambarcaţiuni; registru de scară",
                "b) Atestatul de bord; certificatul de tonaj; rolul de echipaj",
                "c) Atestatul de bord; rolul de echipaj"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "53. Scări de pescaj poartă navele care au pescajul de cel puţin :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 1 m",
                "b) 0,50 m",
                "c) 1,20 m"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "54. Ce se înţelege prin “ambarcaţiune mică”, în sensul Regulamentului de Navigaţie pe Dunăre ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Orice navă cu lungimea corpului mai mică de 20 m, cu excepţia ambarcaţiunior mici care remorchează, împing sau duc cuplat nave, altele decât ambarcaţiuni mici, precum şi a bacurilor şi navelor autorizate să transporte mai mult de 12 pasageri",
                "b) Nave a căror lungime şi lăţime ale corpului sunt mai mici de 15 m şi respectiv, 3,50m sau al căror deplasament mediu este mai mic de 15 t, cu excepţia bacurilor, navelor care remorchează, împing sau duc cuplat nave, în afara de ambarcaţiuni mici",
                "c) Nave a căror lungime şi lăţime ale corpului sunt mai mici de 15 m şi respectiv, 3,50 m sau al căror deplasament maxim este mai mic de 10 t, cu excepţia bacurilor, navelor care remorchează, împing sau duc cuplate nave, în afară de ambarcaţiuni mici"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "55. De la ce distanţe aproximative trebuie să fie văzută o lumină clară galbenă, în condiţii de vizibilitate normală ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 2,9-4,6 km",
                "b) 3,0-4,6 km",
                "c) 2,9-4,5 km"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "56. Ce se înţelege prin “serie de sunete foarte scurte “ ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O serie de cel puţin 6 sunete cu o durată de circa ¼ de secundă fiecare",
                "b) O serie de cel puţin 5 sunete cu o durată de ½ de secundă fiecare",
                "c) O serie de cel puţin 7 sunete cu o durată de ⅓ de secundă fiecare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "57. În scopul evitării de a pune în pericol viaţa persoanelor sau de a provoca pagube altor nave, conducătorii pot lua toate măsurile de precauţie, chiar dacă nu sunt prevăzute dispoziţii speciale în Regulamentul de Navigaţie pe Dunăre ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Numai pentru a salva echipajul"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "58. Care dintre situaţiile de mai jos sunt considerate transporturi speciale ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Convoaiele care transportă materiale explozibile şi inflamabile",
                "b) Instalaţiile plutitoare sau materialele plutitoare asamblate a căror deplasare poate constitui un pericol pentru navigaţie şi care au autorizaţie specială",
                "c) Navele şi convoaiele care au la bord bolnavi sau răniţi"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "59. Ce obligaţii aveţi dacă sunteţi conducătorul unei nave şi vă găsiţi în apropierea altei nave avariate, ale cărei persoane sunt în pericol sau nava poate deveni un obstacol pentru navigaţie ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) În măsura în care nu puneţi în pericol siguranţa propriei nave, daţi asistenţă imediat",
                "b) Fiind vorba de persoane în pericol, daţi asistenţă imediat",
                "c) Anunţaţi cea mai apropiată căpitănie de port"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "60. Zona 1 a căii navigabile corespunde unei înălţimi aparente a valurilor de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 0,6 m",
                "b) 1,2 m",
                "c) 2 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "61. Zona a 3-a a căii navigabile corespunde unei înălţimi aparente a valurilor de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 2 m",
                "b) 1,2 m",
                "c) 0,6 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "62. Zona a 2-a a căii navigabile corespunde unei înălţimi aparente a valurilor de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 1,2 m",
                "b) 0,6 m",
                "c) 2 m"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "63. Ce se înţelege prin termenul “barja de împingere” ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Orice navă construită sau special amenajată pentru a fi împinsă",
                "b) Orice navă nepropulsată pentru transport de marfă",
                "c) Orice navă care poate împinge o altă navă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "64. Ce se înţelege prin termenul “barjă de navă maritimă” ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O barjă de împingere construită pentru a fi transportată la bordul navelor maritime şi pentru a naviga pe căile de navigaţie interioară",
                "b) O navă care poate fi împinsă sau remorcată de o navă maritimă",
                "c) O barjă destinată transporturilor pe mare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "65. Ce se înţelege prin termenul “navă care pescuieşte” ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Orice navă care pescuieşte cu ajutorul plasei, a cârmacei, cu traul sau alte mijloace de pescuit care-i reduc capacitatea de manevră",
                "b) Nava construită şi dotată pentru a pescui",
                "c) O navă care pescuieşte cu cârlige sau alte unelte de pescuit, care nu-şi reduce capacitatea de manevră"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "66. Ce se înţelege prin termenul “viteză de siguranţă” ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O viteză la care o navă, un convoi sau formaţie în cuplu poate să adopte măsuri adecvate şi eficace pentru a preveni un abordaj oprindu-se în limitele distanţei cerută de împrejurări şi condiţiile date",
                "b) O viteză la care o navă, un convoi, sau o formaţie în cuplu se poate opri la timp pentru a preveni un abordaj",
                "c) O viteză redusă mai ales în marşul aval la care navele pot evita un abordaj"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "67. Ce se înţelege prin termenul “vizibilitate redusă” ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Înseamnă condiţiile în care vizibilitatea este redusă ca urmare a ceţii, pâclei, viscolului, averselor de ploaie şi alte cauze.",
                "b) Înseamnă condiţiile în care vizibilitatea este redusă ca urmare a fenomenelor meteorologice",
                "c) Înseamnă incapacitatea vizibilităţii spre prova pe o distanţă mai mică de 1 km"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "68. Ce se înţelege prin termenul “şenal“ ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Înseamnă un sector al căii navigabile utilizat pentru navigaţie la un nivel dat şi balizat cu semnale",
                "b) Înseamnă un sector al căii navigabile destinat pentru navigaţie în care se găsesc cele mai mari adâncimi şi balizat cu semnale",
                "c) Înseamnă un sector destinat navigaţiei şi balizat cu semnale"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "69. Ce se înţelege prin termenul “serie de bătăi de clopot“ ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) v-bis Înseamnă două lovituri de clopot",
                "b) Înseamnă trei lovituri de clopot",
                "c) Înseamnă patru lovituri de clopot"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S1",
            "difficulty": 1
        },
        {
            "question": "70. Ce dimensiuni nu trebuie să depăşească convoaiele împinse, pentru a fi considerate ca nave autopropulsate izolate în marş ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Lungime 112 m şi lăţime  12 m",
                "b) Lungime 110 m şi lăţime 15 m",
                "c) Lungime 110 m şi lăţime 12 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "71. Cum pot fi folosite luminile şi proiectoarele ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Este interzis a se folosi lumini sau proiectoare astfel ca ele să poata fi confundate cu luminile sau semnalele menţionate în R.N.D. sau care pot dăuna asupra vizibilităţii acestor lumini sau semnale sau ca ele să producă o orbire care constituie un pericol pentru navigaţie ori pentru circulaţia terestră",
                "b) Este interzisă cu desăvârşire folosirea lor în R.N.D",
                "c) Nu se precizează folosirea lor în R.N.D"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "72. Un împingător ce navigă singur noaptea va purta semnalizarea :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Unei nave izolate",
                "b) Unui convoi prin împingere",
                "c) Unui convoi remorcat"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "73. Ce lumini suplimentare poartă navele în marş ce transportă materiale inflamabile ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină roşie obişnuită la pupa într-un loc potrivit şi la o înălţime astfel încât să fie vizibilă din toate părţile",
                "b) O lumină albastră obişnuită la catarg, vizibilă pe un arc de orizont de 2250",
                "c) O lumină albastră la pupa, într-un loc potrivit şi la o înălţime astfel încât să fie vizibilă din toate părţile"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "74. Care este semnalizarea de noapte în marş a unui convoi remorcat, care foloseşte un remorcher de întărire şi în compunerea sa are una sau mai multe nave, ce transportă material explozibil ? (Navele autopropulsate din capul convoiului sunt în linie de şir)",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Navele poartă luminile ce se cer la un convoi remorcat cu un remorcher de întărire şi în plus: navele care transportă materiale explozibile, la pupa o lumină roşie obişnuită, vizibilă din toate direcţiile, iar nava autopropulsată din capul convoiului trebuie să poarte o lumină roşie clară, dispusă la circa 1 m sub cea mai de jos lumină de catarg, vizibilă pe acelaşi arc de orizont",
                "b) Navele poartă luminile ce se cer la un convoi remorcat cu un remorcher de întărire şi în plus: navele care transportă material explozibil, la pupa o lumină roşie vizibilă din toate părţile, iar toate navele autopropulsate din capul convoiului aprind o lumină obişnuită roşie, dispusă la circa 1 m sub cea mai de jos lumină de catarg vizibilă din toate părţile",
                "c) Navele poartă luminile ce se cer la un convoi remorcat şi în plus : navele care transportă material explozibil aprind la pupa o lumină roşie obişnuită vizibilă din toate părţile, iar toate navele autopropulsate din capul convoiului aprind o a treia lumină roşie clară, dispusă la circa 1 m sub cea mai de jos lumină de catarg vizibilă pe acelaşi arc de orizont"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "75. În staţionare, noaptea, navele în afară de ambarcaţiunile mici şi bacurile de trecere, trebuie să poarte:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină albă puternică, vizibilă pe un arc de orizont de 225 grade, dispusă la 3 m deasupra liniei de încărcare maximă",
                "b) O lumină obişnuită albă, vizibilă din toate părţile, dispusă la cel puţin 3 m deasupra liniei de încărcare maximă",
                "c) O lumină albă obişnuită, vizibilă din toate părţile"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "76. Două lumini albe obişnuite, dispuse la circa 1 m una deasupra celeilalte, vizibile din toate părţile, purtate noaptea de o navă, au semnificaţia unei :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nave ancorate şi, în acelaşi timp, legate la mal neamenajate",
                "b) Nave ancorate ale căror ancore pot constitui pericol pentru navigaţie",
                "c) Nave în imposibilitate de manevră"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "77. Navele care au transportat materiale inflamabile şi nu au fost degazate, în mars ziua, vor purta :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu este prevăzut în Regulamentul de Navigaţie pe Dunăre",
                "b) Un con albastru cu vârful în jos dispus la o astfel de înălţime, încât să fie vizibil din toate direcţiile",
                "c) Un con roşu cu vârful în jos, dispus la o astfel de înălţime, încât să fie vizibil din toate direcţiile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "78. O navă, ziua în marş, care trebuie să fie protejată împotriva valurilor, poate să arboreze două panouri suprapuse, dintre care cel superior este roşu şi cel inferior este alb, dispuse într-un loc de unde să fie vizibile din toate părţile :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu este prevăzut expres în Regulamentul de Navigaţie pe Dunăre",
                "b) Nu",
                "c) Da"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "79. Convoaiele împinse care au una sau mai multe nave ce transportă materiale explozibile, ziua în staţionare vor purta :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Semnalizarea unei nave izolate în staţionare",
                "b) Fiecare navă ce transportă material explozibil câte un con roşu cu vârful în jos dispus astfel încât să fie vizibil din toate părţile",
                "c) La prova convoiului un con roşu cu vârful în jos, iar pe împingător un balon negru şi un con roşu cu vârful în jos. Întreaga semnalizare este dispusă astfel încât să fie vizibilă din toate părţile"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "80. Luminile din figura de mai jos sunt purtate noaptea de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-001.jpg",
            "answers": [
                "a) Două nave cuplate în staţionare ce transportă materiale inflamabile",
                "b) Nave ce transportă materiale inflamabile din ultima dană dintr-un convoi remorcat in marş văzut din pupa",
                "c) Nave în staţionare cu materiale inflamabile la bord aflate în şenal"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "81. Luminile din imaginea de mai jos sunt purtate noaptea de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-002.jpg",
            "answers": [
                "a) O navă ce transportă material inflamabil în staţionare văzută din babord",
                "b) Două nave în staţionare cuplate dintre care una transportă materiale inflamabile văzute din prova",
                "c) O navă ce transportă material inflamabil în staţionare văzută din tribord"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "82. Ce dimensiuni trebuie să aibă cilindrul, conform R.N.D. ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Înălţimea de cel puţin 0,80 m, iar raza de 0,50 m",
                "b) Înălţimea de cel puţin 0,80 m, iar diametrul de cel puţin 0,50 m",
                "c) Înălţimea de cel puţin 0,80 m, iar diametrul de cel puţin 0,60 m"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "83. Care este intensitatea şi arcul de orizont la care poate fi văzută o lumină albă din pupa unei nave ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Clară, 1120 30’",
                "b) Obişnuită, 1370",
                "c) Obişnuită, 1350"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "84. Ce lumini poartă navele ce navigă cu vele ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Două lumini, obişnuite sau clare suprapuse vizibile din toate părţile din care lumina superioară trebuie să fie roşie, iar lumina inferioară verde; aceste lumini trebuie să fie dispuse într-un loc corespunzător, în partea superioară sau în vârful catargului, la o distanţă de cel puţin 1 m una de cealaltă. Luminile din borduri verde/roşu obişnuite şi lumina albă obişnuită de pupa",
                "b) O lumină albă obişnuită, iar la apropierea de o altă navă arată o a doua lumină albă obişnuită la prova",
                "c) Două lumini albe obişnuite la prova"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "85. Care este semnalizarea de noapte a unui convoi împins în marş care are una sau mai multe nave ce transportă material inflamabil ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Semnalizarea de noapte a unui convoi împins plus o lumină albastră obişnuită, dispusă la circa 2,2 m sub lumina albă superioară din prova, vizibilă pe un arc de orizont de 2250 şi o lumină albastră obişnuită vizibilă din toate părţile la împingător",
                "b) Semnalizarea de noapte a unui convoi împins plus o lumină albastră puternică dispusă la circa 2,2,m deasupra lumini superioare albe din prova vizibilă pe acelaşi arc de orizont, şi câte o lumină albastră obişnuită, vizibilă din toate părţile la nava sau navele care transportă materiale inflamabile",
                "c) Semnalizarea de noapte a unui convoi împins plus o lumină roşie obişnuită dispusă la circa 2,2 m deasupra luminii albe superioare din prova, vizibilă pe un arc de orizont de 2250 şi o lumină roşie obişnuită vizibilă din toate părţile la pupa împingătorului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "86. Bacurile de trecere care navigă liber şi izolat, noaptea trebuie să poarte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină de catarg verde clară vizibilă din toate părţile situată sub lumina albă, la circa 1 m pe verticală. Luminile roşu/verde clare din borduri şi o lumină albă obişnuită la pupa",
                "b) O lumină de catarg albă, clară, vizibilă pe un arc de orizont de 3600 situată sub lumina verde clară, la circa 1 m pe verticală. O lumina albă clară vizibilă din faţă şi pe cât posibil şi din spate dispusă la extremitatea bacului, situată în sensul marşului",
                "c) O lumină de catarg albă clară vizibilă din toate părţile situată sub lumina verde clară la circa 1m pe verticală. Lumina verde este situată la maximum 6 m deasupra liniei de încărcare maximă. Luminile roşu/verde clare din borduri şi o lumină albă obişnuită la pupa"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "87. Bacurile care navigă liber, noaptea, în staţionare la debarcadrul lor, când întrerup activitatea, vor purta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină de catarg verde obişnuită vizibilă din toate părţile",
                "b) O lumină de catarg albă obişnuită vizibilă din toate părţile",
                "c) O lumină de catarg verde obişnuită. La circa 1 m sub lumina de catarg verde obişnuită este situată o lumină albă obişnuită. Ambele lumini sunt vizibile din toate părţile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "88. Ce semnalizare poartă un convoi remorcat ziua, în timpul marşului, care foloseşte unul sau mai multe remorchere de întărire în linie de şir ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Numai nava autopropulsată din capul convoiului poartă un cilindru mărginit sus şi jos de două benzi negre şi albe, benzile albe fiind la extremităţile cilindrului dispus vertical la prova, astfel încât să fie vizibil din toate părţile",
                "b) Numai nava autopropulsată care are parâmele de remorcă, vor purta cilindrul descris la litera “a”",
                "c) Toate navele autopropulsate vor purta câte un cilindru descris la litera “a”"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "89. Un convoi remorcat, care are una sau mai multe nave ce transportă materiale explozibile, ziua, în marş trebuie să poarte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava autopropulsată din capul convoiului, cât şi navele care transportă materiale explozibile, vor purta un con roşu cu vârful în jos, vizibil din toate părţile",
                "b) Nava autopropulsată din capul convoiului va purta semnalizarea de zi, în marş, a unei nave cu remorcă şi în plus un con roşu cu vârful în sus, vizibil din toate părţile. Fiecare navă din convoi, care transportă material explozibil, va purta câte un con roşu cu vârful în jos, vizibil din toate părţile",
                "c) Nava autopropulsată din capul convoiului va purta semnalizarea de zi, în marş a unei nave cu remorcă şi, în plus, un con roşu cu vârful în jos vizibil din toate părţile. Fiecare navă din convoi, care transportă explozibil, va purta câte un con roşu cu vârful în jos vizibil din toate părţile"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "90. Navele care transportă material inflamabil, ziua în staţionare, vor fi semnalizate cu :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un con albastru cu vârful în jos, dispus astfel încât să fie vizibil din toate părţile",
                "b) Un con albastru cu vârful în sus, dispus la cel puţin 6 m deasupra liniei de încărcare maximă",
                "c) Nu se semnalizează"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "91. O navă care trebuie să fie protejată împotriva valurilor, ziua în staţionare, poate purta două panouri suprapuse, dintre care cel superior este roşu şi cel inferior este alb, dispuse astfel încât să fie vizibile din toate părţile ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Regulamentul de Navigaţie pe Dunăre nu precizează expres această situaţie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "92. Luminile din figura de mai jos, reprezintă :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-003.jpg",
            "answers": [
                "a) Un bac de trecere, ce navigă liber, noaptea, văzut din prova",
                "b) Un bac de trecere, ce nu navigă liber, noaptea, văzut din prova",
                "c) Un bac de trecere, ce navigă liber, noaptea, văzut din pupa"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "93. Luminile din imaginea de mai jos, sunt purtate de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-004.jpg",
            "answers": [
                "a) O navă în staţionare ce transportă material exploziv",
                "b) O navă ce trebuie protejată împotriva valurilor",
                "c) O navă în marş, ce transportă material exploziv"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "94. Luminile din imaginea de mai jos, sunt purtate noaptea, de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-005.jpg",
            "answers": [
                "a) Aparate plutitoare în lucru şi nave care efectuează lucrări în calea navigabilă",
                "b) Nave în staţionare, ce transportă material inflamabil şi trebuie protejate împotriva valurilor",
                "c) Nave ancorate, a căror ancoră poate prezenta pericol pentru navigaţie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "95. Ce lumini trebuie să poarte, noaptea, ambarcaţiunile mici autopropulsate, a căror lungime a corpului nu depăşeşte 20 m, care remorchează sau duc în cuplu ambarcaţiuni mici ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu este prevăzut în R.N.D.",
                "b) Luminile unei nave autopropulsate, cu convoi remorcat sau în cuplu",
                "c) Luminile unei ambarcaţiuni mici autopropulsate ce navigă izolat şi a cărei lungime nu depaşeşte 20 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "96. Ce lumini trebuie să poarte navele autopropulsate în, cazul când nava autopropulsată din capul convoiului este precedată de una sau mai multe nave autopropulsate de întărire, navigând în linie de şir ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Fiecare navă autopropulsată adaugă a treia lumină albă la catarg, cu aceleaşi caracteristici ca şi celelalte două lumini",
                "b) Adaugă o a treia lumină albă la catarg cu aceleaşi caracteristici ca şi celelalte două lumini, numai nava autopropulsată din capul convoiului",
                "c) Fiecare navă poartă luminile unei nave autopropulsate cu convoi remorcat"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "97. Ce lumini pot să poarte noaptea, ambarcaţiunile mici autopropulsate, ce nu depăşesc 7 m, în marş ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină albă obişnuită, dispusă într-un loc corespunzător şi la o înălţime de la care să fie vizibilă din toate părţile",
                "b) Două lumini albe obişnuite la catarg",
                "c) Luminile unei nave autopropulsate în marş"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "98. Care este semnalizarea de noapte suplimentară a navelor nepropulsate în marş, ce transportă material explozibil ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Lumina albastră obişnuită la pupa, într-un loc şi o înălţime potrivită pentru a putea fi vizibilă din toate părţile",
                "b) O lumină roşie obişnuită la pupa, dispusă într-un loc şi la o înălţime potrivită, pentru a putea fi vizibilă din toate părţile",
                "c) O lumină roşie clară la pupa, dispusă într-un loc şi la o înălţime potrivită pentru a putea fi văzută din toate părţile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "99. Care este semnalizarea de noapte suplimentară a navelor în marş ce trebuie protejate împotriva valurilor ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină roşie obişnuită şi o lumină albă obişnuită dispuse la circa 1 m una deasupra celeilalte, lumina roşie fiind deasupra şi într-un loc, astfel încât să fie vizibile din toate părţile şi să nu se confunde cu alte lumini",
                "b) O lumină roşie obişnuită şi o lumină albă obişnuită, dispuse la circa 1 m una deasupra celeilalte, lumina albă fiind deasupra şi într- un loc, astfel încât să fie vizibile din toate părţile şi să nu se confunde cu alte lumini",
                "c) O lumină roşie obişnuită şi o lumină albă obişnuită dispuse la circa 1 m una deasupra celeilalte, lumina roşie fiind deasupra, vizibile din faţă pe un arc de orizont de 2250 (câte 112 grade 30’ în fiecare bord) şi într-un loc unde să nu se confunde cu alte lumini"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "100. Ce distanţă minimă trebuie să se respecte între nave, în staţionare, dacă una din ele transportă materiale explozibile ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 50 m",
                "b) 40 m",
                "c) 30 m"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "101. Ce semnalizare de zi, în marş, poartă un convoi împins ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Aceeaşi semnalizare ca un convoi remorcat",
                "b) Nu este prevăzut în R.N.D.",
                "c) O bulă neagră"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "102. Bacurile de trecere, care navigă liber şi a căror lungime depăşeşte 20 m, ziua, în marş, trebuie să poarte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un balon verde, dispus la o înălţime de cel puţin 6 m deasupra liniei de încărcare maximă",
                "b) Nici o semnalizare",
                "c) Nu este prevăzut expres în Regulamentul de Navigaţie pe Dunăre"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "103. Atunci când un convoi împins se află în staţionare ziua, şi are una sau mai multe nave ce transportă material inflamabil, va fi semnalizat astfel :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Fiecare navă ce transportă material inflamabil, câte un con albastru cu vârful în jos, dispus astfel, încât să fie vizibil din toate părţile",
                "b) La prova convoiului un con albastru cu vârful în jos, iar la prova împingătorului un balon negru şi un con albastru, cu vârful în jos. Semnalele sunt dispuse într-un loc potrivit, astfel încât, să fie vizibil din toate părţile",
                "c) Poartă semnalizarea unei nave izolate aflată în staţionare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "104. Ce semnalizare de zi vor purta aparatele plutitoare sau navele ce efectuează lucrări în calea navigabilă ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) În părţile unde şenalul este liber, două biconuri verzi, dispuse la distanţa de 1 m, unul deasupra celuilalt; în partea în care şenalul nu este liber, un balon roşu instalat la aceeaşi înălţime cu biconul superior din cele două biconuri verzi; întreaga semnalizare trebuie să fie vizibilă din toate părţile",
                "b) În partea unde şenalul este liber, un pavilion a cărui jumătate superioară este roşie, iar jumătatea inferioară este albă şi în partea unde şenalul este închis, un pavilion roşu, dispus la aceeaşi înâlţime ca şi pavilionul roşu-alb, purtat pe cealaltă parte. Întreaga semnalizare trebuie să fie vizibilă din toate părţile",
                "c) În partea unde şenalul este liber, un pavilion a cărui jumătate superioară este albă, iar jumătatea inferioară este roşie, iar in partea unde şenalul este închis, un pavilion roşu dispus la aceeaşi înălţime ca şi pavilionul roşu-alb purtat de cealaltă parte. Întreaga semnalizare trebuie să fie vizibilă din toate părţile"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "105. Luminile din figura de mai jos, sunt purtate, pe timp de vizibilitate redusă, de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-006.jpg",
            "answers": [
                "a) Nava din capul unui convoi împins, văzută din prova",
                "b) Nava autopropulsată din capul unui convoi remorcat, văzută din prova",
                "c) Pe timp de vizibilitate redusă, nu se aprind luminile de navigaţie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "106. Indicaţi ce nave şi când poartă luminile din figura de mai jos.",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-007.jpg",
            "answers": [
                "a) Două nave autopropulsate, ce navigă cuplat, noaptea, văzute din prova",
                "b) Navele autopropulsate din capul unui convoi remorcat care are un remorcher de întărire şi navigă, cuplat, noaptea, văzute din prova",
                "c) Nave autopropulsate, care pescuiesc noaptea cu plase la apă, în şenal, văzute din prova"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "107. Ce lumini trebuie să poarte navele autopropulsate din capul unui convoi remorcat, care navigă una lângă alta, cuplate sau nu ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava autopropulsată din capul convoiului care are remorcile poartă trei lumini albe puternice la catarg, dispuse pe verticală, luminile din borduri roşu-verde clare şi lumina galbenă obişnuită la pupa. Celelalte nave autopropulsate din capul convoiului ce navigă cuplate sau nu, poartă luminile unei nave care are convoi la remorcă",
                "b) Fiecare navă autopropulsată din capul unui convoi remorcat, care navigă alături, cuplate sau nu, poartă trei lumini albe puternice la catarg, dispuse pe verticală, luminile roşu- verde clare în borduri şi lumina galbenă obişnuită la pupa",
                "c) Fiecare navă autopropulsată din capul unui convoi remorcat, care navigă alături, cuplate sau nu, poartă luminile unei nave autopropulsate, care are convoi la remorcă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "108. Care este semnalizarea suplimentară de noapte a unui convoi împins în marş, care are una sau mai multe nave ce transportă materiale explozibile ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Semnalizarea de noapte a unui convoi împins, plus o lumină roşie obişnuită, dispusă la circa 2,2 m sub lumina superioară din prova vizibilă pe un arc de orizont de 225 grade şi o lumină roşie obişnuită, vizibilă din toate părţile la împingător",
                "b) Semnalizarea de noapte a unui convoi împins plus o lumină albastră puternică dispusă la circa 2,2 m sub lumina albă superioară din prova vizibilă pe acelaşi arc de orizont şi câte o lumină albastră obişnuită, vizibilă din toate părţile la navele ce transportă material explozibil",
                "c) Semnalizarea de noapte a unui convoi împins plus o lumină roşie clară, dispusă la circa 2,2 m sub lumina superioară albă puternică din prova, vizibilă pe un arc de orizont de 225 grade şi o lumină roşie clară, vizibilă din toate părţile la împingător"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "109. Ambarcaţiunea mică legată la mal, noaptea, cu excepţia bărcilor de serviciu ale navelor trebuie să poarte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină albă obişnuită dispusă într-un loc corespunzător şi la o astfel de înălţime încăt să fie vizibilă din toate părţile",
                "b) Nu este obligatorie semnalizarea",
                "c) O lumină albă obişnuită dispusă la cel puţin 3 m deasupra liniei de încărcare maximă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "110. Ce semnalizare poartă, noaptea, navele a căror ancoră prezintă pericol pentru navigaţie ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Ancora respectivă va fi semnalizată printr-o geamandură sau flotor, având două lumini albe obişnuite, vizibile din toate părţile",
                "b) Ancora respectivă va fi semnalizată printr-o geamandură sau flotor, având două lumini albe obişnuite, suprapuse la circa 1 m distanţă una de alta şi vizibile din toate părţile",
                "c) Lumina de staţionare: care se găseşte cel mai aproape de ancora respectivă, trebuie să fie înlocuită prin două lumini albe obişnuite, suprapuse la circa 1 m distanţă una faţă de alta şi vizibile din toate părţile, iar fiecare din ancorele sale care pot constitui un pericol pentru navigaţie printr-un flotor cu reflector radar care poartă o lumină albă obişnuită vizibilă din toate părţile"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "111. Care este semnalizarea de zi suplimentară a navelor în marş, care transportă materiale explozibile ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un con albastru cu vârful în jos, dispus la o astfel de înălţime, încât să fie vizibil din toate părţile",
                "b) Un con roşu cu vârful în sus, dispus într-un loc potrivit astfel încât să fie vizibil din toate părţile",
                "c) Un con roşu cu vârful în jos, dispus într- un loc potrivit şi la o înălţime astfel încât să fie vizibil din toate părţile"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "112. Navele care transportă materiale inflamabile ziua în staţionare sunt obligate să fie semnalizate :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu",
                "b) Da, cu excepţia navelor care fac parte dintr- un convoi împins",
                "c) Regulamentul de Navigaţie pe Dunăre nu prevede expres această situaţie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "113. Plasele sau alte unelte de pescuit ale navelor care pescuiesc, ziua întinse în apropierea şenalului şi care pot prezenta o piedică pentru navigaţie, vor fi semnalizate cu :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Geamanduri, în număr suficient fiecare, purtând câte un pavilion alb pentru a indica poziţia lor",
                "b) Flotoare sau pavilioane galbene, în număr suficient pentru a indica poziţia lor",
                "c) Orice obiecte plutitoare, în număr suficient pentru a indica poziţia lor"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "114. Indicaţi ce navă şi când poartă luminile de mai jos :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-008.jpg",
            "answers": [
                "a) Nava autopropulsată din capul unui convoi remorcat, noaptea în marş văzut din prova",
                "b) Nava autopropulsată din capul unui convoi remorcat noaptea în marş văzut din prova, când în compunerea convoiului se găsesc una sau mai multe nave ce transportă material inflamabil",
                "c) Nava autopropulsată din capul unui convoi remorcat noaptea în marş văzută din prova când în compunerea convoiului se găsesc una sau mai multe nave ce transportă material explozibil"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "115. Luminile din imaginea de mai jos sunt purtate noaptea de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-009.jpg",
            "answers": [
                "a) Un convoi împins în marş văzut din prova",
                "b) Un convoi împins în marş cu o lungime mai mică de 110 m şi o lăţime mai mică de 12 m",
                "c) Un convoi împins în staţionare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "116. Ce alte panouri şi pavilioane sunt interzise de R.N.D. a se folosi ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Cele care împiedică vizibilitatea sau complică identificarea semnalelor prevăzute în R.N.D.",
                "b) Cele care nu au prevăzute  dimensiunile în R.N.D.",
                "c) Nu este prevăzut în R.N.D."
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "117. Care este semnalizarea de noapte a unui convoi împins în marş care depăşeşte 110 m lungime şi 12 m lăţime ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Trei lumini albe puternice, dispuse în triunghi echilateral cu unul din vârfuri în sus, la prova navei care se găseşte în capul convoiului lângă axa longitudinală; luminile roşu-verde clare din borduri, dispuse la partea cea mai lată a convoiului, cât mai aproape de împingător : trei lumini albe obişnuite la pupa împingătorului dispuse pe orizontală",
                "b) Trei lumini albe puternice, dispuse în triunghi echilateral, cu unul din vârfuri în sus, la prova împingătorului, luminile roşu- verde clare din borduri dispuse la partea cea mai lată a convoiului, cât mai aproape de împingător trei lumini albe obişnuite la pupa împingătorului dispuse pe orizontală",
                "c) Trei lumini albe puternice, dispuse în formă de triunghi cu unul din vărfuri în sus, la prova oricărei nave din convoi, luminile roşu-verde clare din borduri dispuse la partea cea mai lată a convoiului, cât mai aproape de împingător, trei lumini albe obişnuite la pupa împingătorului, dispuse pe orizontală, câte o lumină albă obişnuită, la pupa oricărei nave a cărei lăţime totală este vizibilă din pupa"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "118. Ce lumini trebuie să aibă o ambarcaţiune mică cu rame, noaptea în marş ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Trebuie să arate o lumină albă obişnuită vizibilă din toate părţile la apropierea altor nave",
                "b) O lumină albă obişnuită, vizibilă pe întreg orizontul (3600)",
                "c) O lumină albă obişnuită, vizibilă pe un arc de orizont de 2250"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "119. Convoaiele remorcate în marş, ce transportă materiale explozibile, pe timpul nopţii, trebuie să poarte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava autopropulsată din capul convoiului poartă : două lumini albe puternice la catarg dispuse pe verticală şi o lumină roşie clară, vizibilă pe acelaşi arc de orizont ca luminile albe, dispusă la circa 1 m sub cea mai de jos lumină albă; luminile din borduri roşu/verde clare; o lumină galbenă obişnuită la pupa. Ultimele nave din convoi poartă o lumină albă obişnuită la pupa vizibilă pe un arc de orizont de 135 grade (câte 67 0şi 30’în fiecare bord) navele ce transportă material explozibil poartă o lumină roşie obişnuită la pupa, într-un loc potrivit şi la o înălţime astfel încât să fie vizibilă din toate părţile",
                "b) Nava autopropulsată din capul convoiului poartă două lumini albe puternice la catarg, dispuse pe verticală şi o lumină albastră clară, vizibilă pe acelaşi arc de orizont ca lumină albă dispusă la circa 1 m sub cea mai de jos lumină albă; luminile din borduri roşu/verde clare; o lumină galbenă obişnuită la pupa. Ultimele nave din convoi poartă lumina albă obişnuită la pupa, vizibilă pe un arc de orizont de 135 grade. Navele ce transportă material explozibil poartă o lumină albastră obişnuită la pupa, dispusă într-un loc vizibil şi la o înălţime astfel încât să fie vizibilă din toate părţile",
                "c) Nava autopropulsată din capul convoiului poartă : două lumini albe puternice la catarg dispuse pe verticală, şi o lumină roşie clară, vizibilă pe acelaşi arc de orizont ca lumina albă, dispusă la circa 1 m sub cea mai de jos lumină albă : luminile din borduri roşu/verde clare : o lumină galbenă obişnuită la pupa. Ultimele nave din convoi, poartă lumina albă obişnuită la pupa vizibilă pe un arc de orizont de 135 grade. Navele ce transportă material explozibil (poartă în plus o lumină verde obişnuită la pupa, într-un loc potrivit şi la o înălţime astfel încât să fie vizibilă din toate părţile"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "120. Fiind în imposibilitate de manevră cu nava, noaptea, fără a fi eşuată, scufundată sau în staţionare normală, ce semnalizare vizuală suplimentară folosiţi ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Agitaţi o lumină roşie",
                "b) Arboraţi la catarg 2 lumini roşii obişnuite una deasupra celeilalte având distanţa de circa 1 m între ele vizibile din toate părţile",
                "c) Agitaţi orice obiect vizibil de la navă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "121. Noaptea în staţionare, navele de pescuit inclusiv ambarcaţiunile de pescuit cu plase la apă ce pot prezenta o piedică pentru navigaţie vor fi semnalizate cu :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Două lumini albe obişnuite una deasupra celeilalte cea mai de jos la cel puţin 3 m deasupra liniei de încărcare maximă vizibile din toate părţile",
                "b) O lumină albă obişnuită vizibilă din toate părţile dispusă la cel puţin 3 m deasupra liniei de încărcare maximă",
                "c) O lumină albă obişnuită vizibilă din toate părţile dispusă la cel puţin 3 m deasupra liniei de încărcare maximă şi plasele sau uneltele de pescuit semnalizate prin lumini albe obişnuite într-un număr suficient pentru a indica poziţia lor"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "122. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-010.jpg",
            "answers": [
                "a) Permitere de a staţiona pe o lăţime a suprafeţei de apă cuprinsă între cele 2 distanţe măsurate de la semnal şi indicate în metri pe acesta",
                "b) Interzicerea de a staţiona pe o lăţime cuprinsă între 30-60 m",
                "c) Permiterea de a staţiona în afara semnalului indicat"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "123. Bacurile de trecere a căror lungime depăşeşte 20 m, ziua în marş trebuie să poarte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un balon verde deasupra unui balon alb la circa 1 m distanţă, balonul alb la cel puţin 6 m deasupra liniei de încărcare maximă",
                "b) Un balon alb deasupra unui balon verde la circa 1 m distanţă , balonul verde la cel puţin 6 m deasupra liniei de încărcare maximă",
                "c) Un balon verde dispus la înălţimea de cel puţin 6 m deasupra liniei de încărcare maximă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "124. Ce semnalizare de zi vor purta navele în staţionare care transportă material explozibil ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un con albastru cu vârful în jos dispus astfel încât să fie vizibil din toate părţile",
                "b) Nu se semnalizează",
                "c) Un con roşu cu vârful în jos dispus astfel încât să fie vizibil din toate părţile"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "125. Ziua, navele a căror ancore sunt fundarisite într-un mod în care pot constitui un pericol pentru navigaţie trebuie să-şi semnalizeze fiecare din ancore astfel :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Ancora din dreapta cu un flotor verde şi ancora din stânga cu un flotor roşu",
                "b) R.N.D. nu precizează expres această situaţie",
                "c) Fiecare ancoră cu un flotor galben cu reflector radar"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "126. Luminile din figura de mai jos, sunt purtate noaptea de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-011.jpg",
            "answers": [
                "a) O navă în staţionare ce trebuie protejată împotriva valurilor",
                "b) O navă în marş ce transportă material inflamabil",
                "c) O navă în staţionare ce transportă material explozibil"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "127. Indicaţi ce nave şi când poartă luminile din figura de mai jos :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-012.jpg",
            "answers": [
                "a) Două nave autopropulsate ce navigă cuplat noaptea văzute din prova",
                "b) Navele autopropulsate în cuplu ale unui convoi remorcat care are un remorcher de întărire şi navigă cuplat noaptea văzute din prova",
                "c) Nave autopropulsate care pescuiesc noaptea cu plasa la apă în şenal văzute din prova"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "128. Ce dimensiuni trebuie să aibă pavilioanele şi panourile pentru a asigura o bună vizibiliate ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Cel puţin 1 m lungimea şi 1 m lăţimea",
                "b) Cel puţin 0,80 m lungimea şi 0,80 m lăţimea",
                "c) Cel puţin 1,20 m lungimea şi 1,20 m lăţimea"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "129. Care este intensitatea şi arcul de orizont la care poate fi văzută lumina albă de la catarg ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Clară 112 grade 30'",
                "b) Puternică 135 grade",
                "c) Puternică 225 grade"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "130. La ce distanţă sunt dispuse una faţă de alta luminile de pupa ale împingătorului cu convoi ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Circa 1 m",
                "b) Circa 1,25 m",
                "c) Circa 1,10 m"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "131. Care este semnalizarea de noapte în marş a unui convoi împins care foloseşte un remorcher de întărire ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Poartă semnalizarea unui convoi prin împingere, iar remorcherul de întărire poartă semnalizarea unei nave autopropulsate din capul unui convoi remorcat",
                "b) Întreg ansamblu poartă semnalizarea unui convoi remorcat",
                "c) Întreg ansamblu poartă luminile unui convoi împins"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "132. Ce lumini trebuie să poarte navele autopropulsate din capul unui convoi remorcat, care navigă una lângă alta, cuplate sau nu, iar în compunerea convoiului sunt nave care transportă material explozibil ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Fiecare navă autopropulsată din capul convoiului poartă : trei lumini albe puternice la catarg dispuse vertical şi o lumină roşie clară sub cea mai de jos lumină albă, toate vizibile pe un arc de orizont de 225 grade; luminile roşu/verde clare din borduri, vizibile pe un arc de orizont de 1120 30’ fiecare şi o lumină galbenă obişnuită la pupa vizibilă pe un arc de orizont de 1350",
                "b) Fiecare navă autopropulsată din capul convoiului poartă trei lumini albe puternice la catarg, dispuse vertical şi o lumină albastră clară sub cea mai de jos lumină albă, toate vizibile pe un arc de orizont de 2250; luminile roşu/verde clare din borduri, vizibile pe un arc de orizont de 1120 30’ fiecare şi o lumină galbenă obişnuită la pupa vizibilă pe un arc de orizont de 1350",
                "c) Luminile navelor autopropulsate din capul unui convoi remorcat care navigă una lângă alta, cuplate sau nu, iar una din navele autopropulsate înlocuieşte a treia lumină albă puternică, cu o lumină clară vizibilă pe acelaşi arc de orizont"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "133. Care este semnalizarea de noapte a unei nave în staţionare, care transportă material inflamabil ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) La prova, la cel puţin 3 m deasupra liniei de maximă încărcare, o lumină albă obişnuită vizibilă din toate părţile şi spre pupa o lumină albastră obişnuită, la o asemenea înălţime încât să fie vizibilă din toate părţile",
                "b) O lumină albastră obişnuită spre pupa, într- un loc potrivit şi la o asemenea înălţime încât să fie vizibilă din toate părţile",
                "c) La un loc potrivit şi la o înâlţime de cel puţin 3 m deasupra liniei de maximă încărcare, o lumină albastră obişnuită deasupra unei lumini albe obişnuită, vizibile din toate părţile"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "134. Când o navă poartă un cilindru galben mărginit sus ca şi jos de câte două benzi negre şi albe, benzile albe fiind la extremităţile cilindrului, dispus vertical la prova şi la o înălţime suficientă, pentru a fi vizibil din toate părţile ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Când navigă izolat ziua",
                "b) Când are convoi la remorca în marş ziua",
                "c) Ziua în staţionare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "135. Cum trebuie să fie semnalizat un convoi împins, ziua în marş, care are una sau mai multe nave ce transportă material inflamabil ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) La prova convoiului, un con albastru cu vârful în jos, dispus la o înălţime astfel încât să fie vizibil din toate părţile",
                "b) La prova convoiului cât şi pe împingător, un con albastru cu vârful în jos, dispus la o înălţime astfel încât să fie vizibil din toate părţile",
                "c) Pe fiecare navă ce transportă material inflamabil, cât şi pe împingător, câte un con albastru cu vârful în jos dispus la o înălţime astfel încât să fie vizibil din toate părţile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "136. Ziua navele care merg pentru a da ajutor unei nave în pericol, sunt obligate să fie semnalizate suplimentar ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Nu se prevede expres în R.N.D."
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "137. Două sau mai multe nave, care transportă material explozibil acostate la cheu sau la mal, una lângă alta, ziua vor fi semnalizate astfel :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Toate navele vor purta un con roşu cu vârful în jos",
                "b) Toate navele vor purta câte un con albastru cu vârful în jos",
                "c) Numai nava de la larg va purta la catarg un con roşu cu vârful în jos"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "138. Imaginea de mai jos reprezintă :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-013.jpg",
            "answers": [
                "a) Luminile unei nave autopropulsate, noaptea ancorată",
                "b) Luminile unei nave autopropulsate, noaptea, în imposibitate de manevră",
                "c) Luminile unei nave ancorate noaptea, a cărei ancoră prezintă pericol pentru navigaţie"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "139. Luminile de mai jos sunt purtate noaptea de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-014.jpg",
            "answers": [
                "a) Instalaţii plutitoare, altele decât nave în staţionare",
                "b) Un convoi împins văzut din pupa, în marş",
                "c) O macara plutitoare în lucru"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "140. Precizaţi dacă cilindrii, baloanele şi conurile prevăzute în R.N.D. :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Pot fi înlocuite cu dispozitive care prezintă de la distanţă aceeaşi aparenţă",
                "b) Nu pot fi înlocuite cu dispozitive care prezintă de la distanţă aceeaşi aparenţă",
                "c) R.N.D nu prevede expres această situaţie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "141. Care este intensitatea şi arcul de orizont la care pot fi văzute luminile roşu/verde din borduri ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Clară 112 grade 30’",
                "b) Obişnuită 112 grade 30’",
                "c) Clară 67 grade 30’"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "142. La ce distanţă sunt dispuse una faţă de alta, luminile din prova unui convoi împins ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Ambele lumini inferioare trebuie să fie dispuse la distanţa de 1 m una faţă de alta şi la cca. 1,10 m sub lumina superioară",
                "b) Ambele lumini inferioare trebuie să fie dispuse la o distanţă de cca 1,25 m una faţă de alta şi la cca. 1m sub lumina superioară",
                "c) Ambele lumini inferioare trebuie să fie dispuse la o distanţă de cca.1,25 m una faţă de alta şi la cca. 1,10 m sub lumina superioară"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "143. Care este semnalizarea de noapte a unui convoi remorcat în marş care are una sau mai multe nave ce transportă material inflamabil ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Poartă luminile unui convoi remorcat, plus o lumină albastră, obişnuită sub cea mai de jos lumină de la catarg, vizibilă din toate părţile şi câte o lumină albastră obişnuită la pupa navei sau navelor care transportă material inflamabil, vizibilă pe un arc de orizont de 225 grade",
                "b) Poartă luminile unui convoi remorcat, plus o lumină roşie obişnuită sub cea mai de jos lumină de la catarg, vizibilă din toate părţile şi câte o lumină roşie obişnuită la pupa navei sau navelor ce transportă material inflamabil, vizibile pe un arc de orizont de 225 grade (câte 112 grade 30” în fiecare bord)",
                "c) Poartă luminile unui convoi remorcat, plus o lumină albastră obişnuită, sub cea mai de jos lumină de la catarg, vizibilă pe acelaşi arc de orizont şi câte o lumină albastră obişnuită la pupa navei sau navelor care transportă material inflamabil într-un loc potrivit şi la o înălţime astfel încât să fie vizibilă din toate părţile"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "144. Bacurile de trecere care nu navigă liber, noaptea, trebuie să poarte:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină de catarg verde clară vizibilă din toate părţile. Sub lumina verde, pe verticală la cca.1m o lumină albă clară vizibilă din toate părţile dispusă la minim 5 m deasupra liniei de încărcare",
                "b) O lumină de catarg albă clară vizibilă din toate părţile. Sub lumina albă, pe verticală la cca. 1 m, o lumină verde clară vizibilă din toate părţile dispusă la minimum 5 m deasupra liniei de încărcare maximă. O lumină albă clară vizibilă din faţă şi pe cât posibil şi din spate, dispusă la extremitatea bacului situată în sensul marşului",
                "c) O lumină de catarg verde clară vizibilă din toate părţile. Sub lumina verde pe verticală la cca. 1 m o lumină albă clară vizibilă din toate părţile dispusă la maxim 5 m deasupra liniei de încărcare maximă. Luminile roşu/verde clare din borduri şi o lumină albă obişnuită la pupa"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "145. Care este semnalizarea de noapte a unei nave în staţionare, care transportă material explozibil ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină albă obişnuită la prova vizibilă din toate părţile, la cel puţin trei metri deasupra liniei de încărcare maximă, o lumină roşie obişnuită la pupa, vizibilă din toate părţile",
                "b) O lumină albă obişnuită la cel puţin 3 m deasupra liniei de încărcare maximă. La cca.1 m sub lumina albă, o lumină roşie obişnuită. Ambele lumini vizibile din toate părţile",
                "c) O lumină roşie obişnuită, vizibilă din toate părţile la cel puţin 3 m deasupra liniei de încărcare maximă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "146. Noaptea, ancorele aparatelor plutitoare, care pot prezenta un pericol pentru navigaţie, sunt semnalizate printr-o :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Geamandură sau flotor cu reflector radar având o lumină albă obişnuită vizibilă din toate părţile",
                "b) Geamandură sau flotor având o lumină galbenă obişnuită vizibilă din toate părţile",
                "c) Geamandură sau flotor, având două lumini albe obişnuite una deasupra celeilalte ambele vizibile din toate părţile"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "147. Un convoi remorcat, care are una sau mai multe nave ce transportă material inflamabil ziua în marş trebuie să poarte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava autopropulsată din capul convoiului cât şi nava (navele) care transportă materiale inflamabile, un con albastru cu vârful în jos vizibil din toate părţile",
                "b) Nava autopropulsată din capul convoiului va purta semnalizarea de zi în marş a unei nave cu remorcă şi în plus un con albastru cu vârful în sus vizibil din toate părţile. Fiecare navă din convoi care transportă materiale inflamabile câte un con albastru cu vârful în jos vizibil din toate părţile",
                "c) Nava autopropulsată din capul convoiului va purta semnalizarea de zi în marş a unei nave cu remorcă şi în plus, un con albastru cu vârful în jos vizibil din toate părţile. Fiecare navă din convoi care transportă material inflamabil câte un con albastru cu vârful în jos vizibil din toate părţile"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "148. Ce semnalizare suplimentară vor purta, ziua, navele care merg pentru a da ajutor unei nave aflate în pericol ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu se semnalizează suplimentar",
                "b) O flamură roşie dispusă la cel puţin 6 m deasupra liniei de maximă încărcare",
                "c) O flamură roşie ridicată la prova la o înălţime suficientă ca să fie bine vizibilă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "149. Care este semnalizarea de zi a navelor staţionate, ce trebuie protejate împotriva valurilor ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un pavilion a cărui jumătate superioară este roşie şi jumătatea inferioară albă, dispus la un loc de unde poate fi vizibil din toate părţile",
                "b) O bulă roşie deasupra unei bule albe, dispuse la o astfel de înălţime, încât să fie vizibilă din toate părţile",
                "c) Două pavilioane suprapuse, dintre care cel superior este alb şi cel inferior este roşu dispuse astfel încât să fie vizibile din toate părţile"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "150. Imaginea de mai jos reprezintă :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-015.jpg",
            "answers": [
                "a) Luminile unei nave autopropulsate din capul unui convoi în marş noaptea văzute din prova",
                "b) Luminile unei nave autopropulsate izolate în marş noaptea văzute din prova",
                "c) Luminile unui convoi împins în marş noaptea văzute din prova"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "151. Luminile din imaginea de mai jos sunt purtate noaptea de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-016.jpg",
            "answers": [
                "a) Nava autopropulsată din capul unui convoi remorcat văzut din prova",
                "b) Un bac de trecere autopropulsat în marş",
                "c) O navă autopropulsatş izolată în marş văzută din prova"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "152. Luminile din figura de mai jos sunt purtate noaptea de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-017.jpg",
            "answers": [
                "a) Un bac autopropulsat în marş",
                "b) Un bac ce nu navigă liber în marş",
                "c) Un bac ce nu navigă liber în staţionare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "153. Care sunt dimensiunile unui balon ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Diametru de cel puţin 0,80 m",
                "b) Diametru de cel puţin 0,65 m",
                "c) Diametru de cel puţin 0,60 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "154. Care este intensitatea şi arcul de orizont la care poate fi văzută lumina galbenă de pupa a unui remorcher cu convoi ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Obişnuiţă 135º",
                "b) Obişnuită 137º",
                "c) Obişnuită 112º30'"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "155. Ce lumini trebuie să poarte navele cu vele în marş şi unde ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Luminile unei nave izolate autopropulsate în marş sau dacă sunt ambarcaţiuni mici, luminile ambarcaţiunilor mici",
                "b) O singură lumină albă obişnuită iar la apropierea de o navă să arate o a doua lumină albă la prova",
                "c) Două lumini obişnuite sau clare suprapuse vizibile din toate părţile din care lumina superioară trebuie să fie roşie, iar lumina inferioară verde. Aceste lumini trebuie să fie dispuse, într-un loc corespunzător în partea superioară sau în vârful catargului la distanţă de cel puţin 1 m una de cealaltă. Luminile din borduri verde şi roşu şi lumina albă de pupa"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "156. Care este semnalizarea de noapte în marş a unui convoi remorcat care foloseşte un remorcher de întărire şi în compunerea sa are una sau mai multe nave care transportă materiale inflamabile (navele autopropulsate din capul convoiului sunt în linie de şir) ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Navele poartă luminile ce se cer la un convoi remorcat şi în plus; navele care transportă material inflamabil aprind la pupa o lumină albastră iar nava autopropulsată din capul convoiului trebuie să poarte o lumină albastră obişnuită dispusă la circa 1 m sub cea mai de jos lumină de catarg vizibilă pe acelaşi arc de orizont",
                "b) Navele poartă luminile ce se cer la un convoi remorcat cu remorcher de întărire şi în plus navele care transportă material inflamabil aprind la pupa o lumină albastră vizibilă din toate părţile, la toate navele autopropulsate din capul convoiului aprind o lumină albastră obişnuită dispusă la circa 1 m sub cea mai de jos lumină de catarg vizibilă pe acelaşi arc de orizont",
                "c) Navele poartă luminile ce se cer la un convoi remorcat şi în plus navele care transportă material inflamabil aprind la pupa o lumină albastră obişnuită vizibilă din toate părţile, iar toate navele autopropulsate din capul convoiului aprind a treia lumină albastră obişnuită dispusă la circa 1 m sub cea mai de jos lumină de catarg vizibilă pe acelaşi arc de orizont"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "157. Semnalizarea de noapte a bacurilor care navigă liber şi se bucură de prioritate este că a :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Bacurilor de trecere care navigă liber",
                "b) Bacurilor de trecere care nu navigă liber",
                "c) Bacurilor de trecere care navigă liber la care se adaugă o a doua lumină verde clară vizibilă din toate părţile şi dispusă la o distanţă de aproximativ 1 m deasupra luminii verzi"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "158. Care este semnalizarea de noapte suplimentară a navelor în staţionare care trebuie să fie protejate împotriva valurilor ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină albă obişnuită şi o lumină roşie obişnuită dispusă la circa 1 m una deasupra celeilalte. Lumina albă fiind deasupra, vizibilă din toate părţile",
                "b) O lumină roşie obişnuită şi o lumină albă obişnuită dispusă la circa 1 m una deasupra celeilalte. Lumina roşie fiind deasupra, vizibilă din toate părţile",
                "c) Două lumini roşii obişnuite una sub alta la circa 1 m distanţă vizibile din toate părţile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "159. Un convoi remorcat de două nave autopropulsate care navigă una alături de cealaltă ziua în marş va purta :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Numai navele autopropulsate vor purta fiecare câte un cilindru galben mărginit sus şi jos de câte două benzi negre şi albe, benzile albe fiind la extremitatea cilindrului dispus vertical la prova la o înălţime suficientă pentru a fi vizibil din toate părţile",
                "b) Numai nava autopropulsată care are date remorcile la convoi va purta un cilindru descris la litera a",
                "c) Toate navele autopropulsate cât şi o navă din ultima dană a convoiului vor purta un cilindru descris la litera a"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "160. Cum trebuie să fie semnalizat un convoi împins ziua în marş care are una sau mai multe nave ce transportă material explozibil :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) La prova convoiului un con roşu cu vârful în jos dispus la o înălţime astfel încât să fie vizibil din toate părţile",
                "b) În prova convoiului, cât şi pe împingător un con roşu cu vârful în jos dispus la o înălţime astfel încât să fie vizibil din toate părţile",
                "c) Pe fiecare navă care transportă material explozibil, cât şi pe împingător câte un con roşu cu vârful în jos dispus la o înălţime astfel încât să fie vizibil din toate părţile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "161. Două sau mai multe nave care transportă material inflamabil acostate la cheu sau la mal neamenajat una lângă alta ziua, vor fi semnalizate astfel :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Toate navele vor purta câte un con albastru cu vârful în jos",
                "b) Numai ultima navă de la larg va purta un con albastru cu vârful în jos",
                "c) Toate navele vor purta câte un con roşu cu vârful în jos"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "162. Ce indică semnalul alăturat ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-018.jpg",
            "answers": [
                "a) Puncte periculoase de la malul stâng",
                "b) Puncte periculoase de la malul drept",
                "c) Puncte periculoase în şenal"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "163. Luminile din figura alăturată sunt văzute noaptea la :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-019.jpg",
            "answers": [
                "a) O construcţie plutitoare în staţionare",
                "b) Pupa navei autopropulsate la un convoi împins în marş",
                "c) Pupa unui împingător ce navigă izolat"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "164. Luminile din imaginea alăturată, sunt purtate noaptea de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-020.jpg",
            "answers": [
                "a) Instalaţii plutitoare, altele decât nave în staţionare",
                "b) Nave eşuate indicând contururile lor",
                "c) Instalaţii plutitoare altele decât nave în marş"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "165. Care sunt dimensiunile unui con ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Înălţimea de cel puţin 0,80 m şi diametrul bazei de cel puţin 0,50 m",
                "b) Înălţimea de cel puţin 0,80 m şi raza bazei de cel puţin 0,50 m",
                "c) Înălţimea de cel puţin 0,60 m şi diametrul bazei de cel puţin 0,60 m"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "166. Ce semnalizare de noapte trebuie să aibă o navă autopropulsată în marş care remorchează un convoi ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină albă puternică la catarg, luminile roşu/verde clare în borduri şi o lumină galbenă obişnuită la pupa",
                "b) Două lumini albe puternice la catarg dispuse pe verticală, luminile roşu-verde clare în borduri şi o lumină galbenă obişnuită la pupa",
                "c) Două lumini albe puternice la catarg dispuse pe verticală, luminile roşu-verde clare în borduri şi o lumină albă obişnuită la pupa"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "167. Ce lumini poartă o ambarcaţiune mică autopropulsată care depăşeşte 7 m noaptea în marş ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Arată o lumină albă la apropierea unei nave",
                "b) Poartă luminile unei nave izolate în marş",
                "c) O lumină albă clară vizibilă din toate părţile la catarg, luminile din borduri roşu/verde obişnuite dispuse în aceeaşi lampă (felinar) în axa ambarcaţiunii la prova sau aproape de prova"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "168. Care este semnalizarea de noapte în marş a unui convoi împins ce transportă material inflamabil şi foloseşte un remorcher de întărire în capul convoiului ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Navele poartă semnalizarea de noapte a unui convoi împins în marş care transportă material inflamabil",
                "b) Navele poartă semnalizarea de noapte a unui convoi remorcat în marş ce transportă material inflamabil",
                "c) Remorcherul de întărire poartă luminile unei nave autopropulsate ce remorchează un convoi ce transportă material inflamabil, iar ansamblu remorcat poartă luminile din pupa ale unui convoi remorcat şi numai luminile albastre prevăzute pentru convoaiele împinse ce transportă material inflamabil"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "169. Ce semnalizare de noapte poartă în marş un ansamblu format dintr-un bac remorcat împins sau dus în cuplu de altă navă autopropulsată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava autopropulsată poartă luminile unei nave care remorchează, împinge sau duce cuplat iar bacul poartă la catarg o lumină verde şi pe verticală dedesubt o lumină albă, ambele vizibile din toate părţile, la pupa o lumină albă",
                "b) Întreg ansamblu va purta semnalizarea unui convoi remorcat, împins sau dus cuplat",
                "c) Nava autopropulsată va purta luminile unui bac, care navigă liber, iar bacul luminile prevăzute pentru o navă remorcată împinsă sau cuplată"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "170. Instalaţiile plutitoare, noaptea în staţionare, trebuie să poarte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Luminile albe obişnuite, în număr suficient pentru a indica contururile lor",
                "b) Lumini de diverse culori, obişnuite, în număr suficient pentru a indica contururile lor în partea şenalului navigabil",
                "c) Lumini albe obişnuite, în număr suficient pentru a indica contururile lor din partea şenalului navigabil"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "171. O navă care navigă cu vele folosind în acelaşi timp şi motor, ziua în marş, trebuie să poarte:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O bulă neagră dispusă la cel puţin 3 m deasupra liniei de maximă încărcare astfel încât să fie vizibilă în toate părţile",
                "b) Un con negru cu vârful în jos, amplasat cât mai sus posibil şi într-un loc unde va fi cel mai vizibil",
                "c) Un con negru cu vârful în sus dispus la cel puţin 3 m deasupra liniei de maximă încărcare, astfel încât să fie vizibil în toate părţile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "172. Toate bacurile de trecere, ziua în marş vor purta un balon verde la o înălţime de cel puţin 6 m deasupra liniei de încărcare maximă :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu",
                "b) Da",
                "c) Nu este prevăzut în R.N.D."
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "173. Tancurile care au transportat materiale inflamabile şi nu au fost degazate, ziua în staţionare vor purta :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) R.N.D. nu prevede expres această situaţie",
                "b) Un con roşu cu vârful în jos dispus într-un loc potrivit astfel încât să fie vizibil din toate părţile",
                "c) Un con albastru cu vârful în jos dispus într-un loc potrivit şi la o înălţime astfel încât să fie vizibil din toate părţile"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "174. Navele eşuate şi scufundate, ziua, trebuie să poarte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un balon roşu şi un balon alb dispuse la cel puţin 1 m unul deasupra celuilalt, balonul roşu fiind deasupra în partea unde şenalul este liber şi, în partea unde şenalul nu este liber un balon roşu dispus la aceeaşi înălţime ca şi balonul roşu plasat de cealaltă parte. Întreaga semnalizare trebuie să fie vizibilă din toate părţile",
                "b) În partea unde şenalul este liber un pavilion a cărui jumătate superioară este roşie, iar jumătate inferioară este albă şi în partea unde şenalul este închis un pavilion roşu dispus la aceeaşi înălţime ca şi pavilionul roşu şi alb purtat de cealaltă parte. Întreaga semnalizare trebuie să fie vizibilă din toate părţile",
                "c) În partea unde şenalul este liber un pavilion a cărui jumătate superioară este albă, iar jumătatea inferioară este roşie şi în partea unde şenalul este închis un pavilion roşu dispus la aceeaşi înălţime ca şi pavilionul alb şi roşu purtat de cealaltă parte. Întreaga semnalizare trebuie să fie vizibilă din toate părţile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "175. Luminile din figura de mai jos sunt purtate de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-021.jpg",
            "answers": [
                "a) Un convoi prin împingere ce navigă noaptea văzut din prova, având în compunerea sa şi nave ce transportă material explozibil",
                "b) Un convoi prin împingere ce navigă noaptea, văzut din prova având în compunerea sa şi nave ce transportă material inflamabil",
                "c) Nava autopropulsată din capul unui convoi remorcat, ce navigă noaptea, văzută din prova, având în convoi cel puţin o navă ce transportă material inflamabil"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "176. Luminile din figura de mai jos sunt purtate, noaptea de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-022.jpg",
            "answers": [
                "a) Un convoi împins în marş văzut din prova având în compunerea sa cel puţin o navă ce transportă material exploxibil",
                "b) Un convoi împins în marş văzut din prova, având în compunerea sa cel puţin o navă ce transportă material inflamabil",
                "c) Un convoi împins în marş văzut din prova"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "177. Semnalizarea prevăzută pentru noapte la nave trebuie să fie purtată, în plus, şi ziua , în condiţii de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Vizibilitate redusă : ceaţă, ninsoare etc",
                "b) Avarie la bordul navei",
                "c) Răniţi sau bolnavi la bord"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "178. Dacă lumina de semnalizare puternică, prevăzută în Regulamentul de Navigaţie pe Dunăre, se defectează, cum trebuie să fie lumina de rezervă ce o înlocuieşte ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Puternică sau clară",
                "b) Obişnuită",
                "c) Nu contează intensitatea"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "179. Cum şi unde trebuie dispuse luminile de catarg ale unui convoi împins ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) La prova navei sau a uneia din navele din capul convoiului, în formă de triunghi echilateral, lângă axa longitudinală",
                "b) La catargul prova al împingătorului, în formă de triunghi echilateral",
                "c) La prova uneia sau a oricărei nave din capul convoiului, în formă de triunghi isoscel"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "180. Ce lumini suplimentare poartă tancurile în marş, care au transportat materiale inflamabile, şi nu au fost degazate ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină albastră obişnuită la pupa, într-un loc potrivit şi la o înălţime astfel încât să fie vizibilă din toate părţile",
                "b) O lumină roşie obişnuită la pupa, într-un loc potrivit şi la o înălţime astfel încât să fie vizibilă din toate părţile",
                "c) Nu este prevăzut în Regulamentul de Navigaţie pe Dunăre"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "181. Ce lumini trebuie să poarte navele autopropulsate din capul unui convoi remorcat, care navigă una lângă alta, cuplate sau nu, iar în compunerea convoiului sunt nave ce transportă material inflamabil ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Fiecare navă autopropulsată din capul convoiului poartă : trei lumini albe puternice la catarg, dispuse vertical şi o lumină roşie clară, sub cea mai de jos lumină albă, toate vizibile pe un arc de orizont de 225 grade, luminile roşu/verde clare din borduri, lumină galbenă de pupa",
                "b) Fiecare navă autopropulsată din capul convoiului poartă 3 lumini albe puternice la catarg dispuse vertical şi o lumină albastră clară sub cea mai de jos lumină albă, toate vizibile pe un arc de orizont de 225 grade, luminile roşu/verde clare în borduri şi o lumină galbenă obişnuită la pupa vizibilă pe un arc de orizont de 135 grade",
                "c) Luminile navelor autopropulsate din capul unui convoi remorcat, care navigă una lângă alta, cuplate sau nu, iar una din navele autopropulsate înlocuieşte a treia lumină albă puternică cu o lumină albastră obişnuită, vizibilă pe acelaşi arc de orizont"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "182. Instalaţiile plutitoare, noaptea în marş, trebuie să poarte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Lumini obişnuite de diverse culori, în număr suficient pentru a arăta dimensiunile construcţiei",
                "b) Lumini albe obişnuite, pentru a arăta dimensiunile construcţiei",
                "c) Lumini albe obişnuite, în număr suficient pentru a indica contururile construcţiei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "183. Ce semnalizare de noapte trebuie să poarte aparatele plutitoare în lucru şi navele care efectuează lucrări în calea navigabilă, precum şi navele eşuate ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Două lumini clare verzi suprapuse la circa 1 m una deasupra celeilalte, în partea unde şenalul este liber şi o lumină roşie clară în partea unde şenalul nu este liber. Lumina roşie este dispusă la aceeaşi înălţime cu lumina verde superioară. Toate luminile sunt vizibile din toate părţile",
                "b) O lumină roşie clară şi o lumină albă clară, dispuse la circa 1 m una deasupra celeilalte, lumina albă fiind cea de sus, în partea unde şenalul nu este liber. Toate luminile sunt vizibile din toate părţile",
                "c) O lumină roşie clară şi o lumină albă clară dispuse la circa 1 m una deasupra celeilalte, lumina roşie fiind cea de sus, în partea unde şenalul nu este liber şi o lumină roşie clară, în partea unde şenalul este liber. Luminile roşii sunt dispuse la aceeaşi înălţime. Toate luminile sunt vizibile din toate părţile"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "184. Care este semnalizarea de zi suplimentară a navelor în marş, care transportă materiale inflamabile ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un con albastru cu vârful în jos, dispus la un loc potrivit şi la o înălţime astfel încât să fie vizibil din toate părţile",
                "b) Un con albastru cu vârful în sus, dispus la un loc potrivit şi la o înălţime astfel încât să fie vizibil din toate părţile",
                "c) Un con roşu cu vârful în jos, dispus la un loc potrivit şi la o înălţime astfel încât să fie vizibil din toate părţile"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "185. Care este semnalizarea de zi suplimentară a navelor în marş, ce trebuie protejate împotriva valurilor ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O bulă roşie deasupra unei bule albe, dispuse într-un loc unde să fie vizibile din toate părţile",
                "b) Un pavilion a cărui jumătate superioară este roşie şi jumătate inferioară este albă, dispus într-un loc potrivit, de unde să fie vizibil din toate părţile",
                "c) Două pavilioane suprapuse, dintre care cel superior este alb şi cel inferior este roşu, dispuse într-un loc potrivit, de unde să fie vizibile din toate părţile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "186. Navele care transportă materiale inflamabile, ziua în staţionare, sunt obligate să fie semnalizate ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu",
                "b) Da. Cu excepţia navelor care fac parte dint- un convoi împins",
                "c) Regulamentul de Navigaţie pe Dunăre nu prevede expres această situaţie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "187. Ziua, navele ale căror ancore fundarisite prezintă un pericol pentru navigaţie, vor semnaliza ancorele prin :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un flotor galben",
                "b) Un pavilion galben",
                "c) Un flotor galben cu reflector radar"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "188. Ce reprezintă imaginea de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-023.jpg",
            "answers": [
                "a) Luminile navei autopropulsate din capul unui convoi remorcat, ce navigă noaptea, văzută din prova, având în compunerea convoiului cel puţin o navă ce transportă material inflamabil",
                "b) Luminile navei autopropulsate din capul unui convoi remorcat, ce navigă noaptea, văzută din prova, având în compunerea convoiului cel puţin o navă ce transportă material explozibil",
                "c) Luminile unei nave autopropulsate, ce navigă izolat noaptea, văzută din prova"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "189. Luminile din figura de mai jos sunt purtate de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-024.jpg",
            "answers": [
                "a) Două nave autopropulsate în staţionare, cuplate, văzute din prova",
                "b) O navă autopropulsată în marş noaptea văzută din prova",
                "c) Două nave, dintre care una autopropulsată, ce navigă cuplat, noaptea, văzute din prova"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "190. Ce semnalizare de noapte trebuie să poarte o navă autopropulsată ce navigă izolat ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină de catarg albă puternică; luminile din borduri roşu/verde clare şi o lumină galbenă obişnuită la pupa",
                "b) O lumină de catarg albă clară; luminile din borduri roşu/verde obişnuite şi o lumină albă clară la pupa",
                "c) O lumină de catarg albă puternică; luminile din borduri roşu/verde clare şi o lumină albă obişnuită la pupa"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "191. Ce dimensiuni trebuie să aibă un bicon ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Înălţimea de 0,8 m şi diametrul de cel puţin 0,5 m",
                "b) Înălţimea de 0,8 m şi raza de cel puţin 0,5 m",
                "c) Înălţimea de 0,8 m şi diametrul de 0,8 m"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "192. Navele autorizate să transporte mai mult de 12 pasageri şi a cărei lungime maximă a corpului nu depăşeşte 20 m trebuie să poarte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un bicon galben amplasat în mod corespunzător şi la o înălţime în aşa fel încât să fie vizibil din toate părţile",
                "b) Două biconuri galbene amplasate la prova şi la o înălţime în aşa fel încât să fie vizibile din toate părţile",
                "c) Nu este prevăzut în prezentul Regulament de Navigaţie pe Dunăre"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "193. Navele în marş care efectuează operaţiuni de sondaj sau de măsurare în calea navigabilă vor purta o lumină galbenă clară, intermitentă vizibilă din toate părţile ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Nu este prevăzut în prezentul Regulament de Navigaţie pe Dunăre"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "194. Navele care acţionează la spargerea gheţii vor purta suplimentar ziua :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Trei baloane roşii dispuse unul sub altul la cca. un metru distanţă",
                "b) Trei baloane galbene dispuse unul sub altul la cca. un metru distanţă",
                "c) Trei baloane negre dispuse unul sub altul la cca. un metru distanţă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "195. Navele care acţionează la spargerea gheţii vor purta suplimentar noaptea :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Trei lumini roşii obişnuite vizibile din toate părţile dispuse una sub alta la cca. un metru distanţă",
                "b) Trei lumini verzi obişnuite vizibile din toate părţile dispuse una sub alta la cca. un metru distanţă",
                "c) Trei lumini galbene obişnuite vizibile din toate părţile dispuse una sub alta la cca. un metru distanţă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S2",
            "difficulty": 1
        },
        {
            "question": "196. Care este semnalizarea suplimentară a navelor de supraveghere fluvială ziua în marş în exercitarea atribuţiunilor lor :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Ca a unei nave izolate",
                "b) Ziua arborează o flamură albă în centrul căreia se găseşte un romb alb încadrat de un chenar albastru",
                "c) Ziua arborează o flamură albă în centrul căreia se găseşte un romb alb încadrat cu un chenar albastru şi arată o lumină albastră intermitentă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "197. Emiterea de către o navă a unui semnal fonic lung pe vizibilitate bună are semnificaţia de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Navigaţie periculoasă",
                "b) Atenţie",
                "c) Semnal premergător intenţiei de a depăşi"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "198. O navă care iese dintr-un bazin portuar sau dintr-un afluent şi se îndreaptă la tribord emite :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Trei sunete lungi",
                "b) Un sunet lung urmat de două sunete scurte",
                "c) Trei sunete lungi urmate de unul scurt"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "199. Care este culoarea, forma şi care sunt caracteristicile unei geamanduri de bifurcaţie ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) De forma sferică vopsită (piturată) în verde-roşu-verde-roşu, lumină de culoare albă intermitentă",
                "b) De forma sferică vopsită (piturată) în alb- negru-alb-negru, lumină de culoare albă intermitentă",
                "c) De forma sferică vopsită (piturată) în roşu-negru-roşu-negru, lumină de culoare albă intermitentă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "200. Care sunt caracteristicile luminii de coastă (far) de bifurcaţie ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Două panouri triunghiulare albe, unul deasupra celuilalt şi opuse la vârf cel de deasupra mărginit cu bandă roşie cel de jos cu bandă verde, lumină albă intermitentă",
                "b) Suport de culoare albă, lumină galbenă fixă , un disc piturat negru-roşu-negru-roşu",
                "c) Suport de culoare albă, lumină albă fixă, un disc piturat roşu-negru-roşu-negru"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "201. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-025.jpg",
            "answers": [
                "a) Interzice staţionarea în zona ambelor maluri",
                "b) Interzicere de a staţiona (de a ancora sau de a se lega la mal)",
                "c) Interzice staţionarea în şenal"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "202. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-026.jpg",
            "answers": [
                "a) Obligă navale de a ţine partea şenalului care se găseşte la tribord",
                "b) Obligă navele de a ţine partea şenalului care se găseşte la babord",
                "c) Obligă navele să efectueze înscrucişări numai prin tribord"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "203. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-027.jpg",
            "answers": [
                "a) Urmează trecerea pe sub pod",
                "b) Înălţimea liberă deasupra apei este limitată",
                "c) Adăncimea apei este limitată"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "204. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-028.jpg",
            "answers": [
                "a) Pericol, asiguraţi-vă",
                "b) Traversarea cu o linie electrică aeriană",
                "c) Traversare hidrocentrală electrică"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "205. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-029.jpg",
            "answers": [
                "a) Calea urmată este considerată ca afluent a căii întâlnite",
                "b) Căile întâlnite sunt considerate ca afluenţi ai căii urmate",
                "c) Obligaţia de a nu se angaja în calea principală sau de a nu Traversa"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "206. Care dintre cele două semnale de mai jos crează obligaţii conducătorilor de nave ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-030.jpg",
            "answers": [
                "a) Semnalul A 10",
                "b) Semnalul D 2",
                "c) Nici unul"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "207. Care sunt semnalele fonice, emise, în cazul unei depăşiri prin tribord atât de nava care ajunge din urmă cât şi de nava ajunsă care poate oferi drumul cerut ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava care ajunge din urmă emite : “un sunet lung urmat de două sunete scurte, nava ajunsă din urmă emite un sunet scurt”",
                "b) Nava care ajunge din urmă emite : “două sunete lungi urmate de un sunet scurt, nava ajunsă din urmă emite două sunete scurte”",
                "c) Nava care ajunge din urmă emite : “două sunete lungi urmate de două sunete scurte, nava ajunsă din urmă emite un sunet scurt”"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "208. Atunci când o navă este în pericol şi vrea să ceară ajutor, poate emite semnale sonore ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Nu este prevăzut în Regulamentul de Navigaţie pe Dunăre"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "209. Nava care emite patru sunete scurte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Este în imposibilitate de a manevra",
                "b) Dă înapoi",
                "c) Este în pericol iminent de abordaj"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "210. O navă izolată, care navigă amonte, cu radar în condiţii de vizibilitate redusă, emite :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Două sunete lungi, emise la cel puţin un minut",
                "b) Trei sunete cu trei tonalităţi diferite, care se succed fară întrerupere",
                "c) Un sunet lung, repetat cel puţin la fiecare minut"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "211. Şcondrii pentru dreapta au culoarea :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Verde",
                "b) Neagră",
                "c) Roşie"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "212. Ce indică semnalul alăturat ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-031.jpg",
            "answers": [
                "a) Traversare de la malul stâng",
                "b) Traversare de la malul drept",
                "c) Jalon de aliniament dreapta"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "213. Ce semnificaţie are semnalul de mai jos :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-032.jpg",
            "answers": [
                "a) În zona respectivă se produc valuri",
                "b) Interzicere de a provoca valuri",
                "c) Interzice provocarea de valuri sau efecte de sugere"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "214. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-033.jpg",
            "answers": [
                "a) Interzice navigaţia convoaielor remorcate sau împinse, cu mai mult de 12 unităţi",
                "b) Obligă navele de a nu depăşi viteza de 12 km/h în raport cu malurile",
                "c) Viteza curentului este mai mare de 12 km/h"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "215. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-034.jpg",
            "answers": [
                "a) Lăţimea trecerii sau a şenalului este limitată",
                "b) Şenalul este depărtat de malul drept (stâng). Menţineţi-vă la 10 m distanţă de semnal",
                "c) Recomandarea de a se îndepărta de malul drept (stâng) în direcţia arătată până la 10 m"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "216. Care dintre cele două semnale de mai jos reprezintă semnalul de interzicere ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-035.jpg",
            "answers": [
                "a) Semnalul A 1",
                "b) Semnalul E 1",
                "c) Atât semnalul A 1 cît şi semnalul E 1"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "217. Care sunt semnalele fonice, emise, în cazul în care se cere depăşire prin tribord, de către nava ce ajunge din urmă, iar nava ajunsă nu poate oferi depăşirea prin tribord şi nava care ajunge din urmă este de acord ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava care ajunge din urmă emite: “două sunete lungi şi două sunete scurte”. Nava ajunsă emite: “două sunete scurte”. Nava care ajunge din urmă emite: “un sunet scurt”",
                "b) Nava care ajunge din urmă emite: “două sunete lungi şi unul scurt”. Nava ajunsă emite : “un sunet scurt”. Nava care ajunge din urmă emite: “două sunete scurte”",
                "c) Nava care ajunge din urmă emite : “două sunete lungi şi două sunete scurte”. Nava ajunsă din urmă emite : “ un sunet scurt”. Nava care ajunge din urmă emite: “ un sunet scurt”"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "218. Se pot folosi lumini şi semnale ce nu sunt prevăzute în R.N.D ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu sunt permise alte semnale decât cele prevăzute în R.N.D",
                "b) Da, numai pentru comunicări între nave, între nave şi uscat, cu condiţia să nu se confunde cu luminile şi semnalele prevăzute de R.N.D",
                "c) Da, numai în sectorul Dunării maritime"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "219. Sunt interzise semnalele fonice între nave sau între navă şi uscat, altele decât cele prevăzute de Regulamentul de Navigaţie pe Dunăre ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Nu este prevăzut expres în Regulamentul de Navigaţie pe Dunăre"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "220. Pentru a întoarce la tribord, o navă trebuie să emită :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) “Un  sunet scurt”  urmat de “un sunet lung”",
                "b) “Un sunet lung”, urmat de  “două sunete scurte”",
                "c) “Un sunet  lung”, urmat de “un sunet scurt”"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "221. O navă care staţionează pe partea dreaptă a şenalului, în condiţii de vizibilitate redusă, emite :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) “O serie simplă de sunete de clopot”, repetate cel puţin la fiecare minut",
                "b) “O serie dublă de sunete de clopot” repetată cel puţin la fiecare minut",
                "c) “O serie triplă de sunete de clopot” repetată cel puţin la fiecare minut"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "222. Pe întregul parcurs navigabil al fluviului, şenalul este balizat după sistemul :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Lateral",
                "b) Cardinal",
                "c) Lateral şi cardinal"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "223. Ce semnificaţie au semnalele de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-036.jpg",
            "answers": [
                "a) Far de intrare în bazin. Mal drept",
                "b) Jalon de alineament dreapta",
                "c) Nici o semnificaţie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "224. Priviţi semnalul de mai jos. Ce semnificaţie are ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-037.jpg",
            "answers": [
                "a) Interzice trecerea",
                "b) Interzice orice depăsire",
                "c) Interzice depăşirea numai între convoaie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "225. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-038.jpg",
            "answers": [
                "a) Obligaţia de a se îndrepta spre partea şenalului situat la babord",
                "b) Obliga navele de a urma direcţia indicată prin săgeată",
                "c) Obliga navele de a se îndrepta spre partea şenalului care se găseşte la tribord"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "226. Care din obligaţiile de mai jos, vă revin când sunteţi de cart la comanda unei nave în marş şi întâlniţi semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-039.jpg",
            "answers": [
                "a) Înaintea angajării în calea principală, să emiteţi semnale sonore prevăzute de R.N.D",
                "b) Să nu vă angajaţi în calea principală sau să nu traversaţi decât dacă  manevra nu obligă alte nave care navigă pe această cale să-şi modifice drumul sau viteza",
                "c) Nu aveţi nici o obligaţie, deoarece semnalul indică prioritate de trecere pentru dumneavoastră"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "227. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-040.jpg",
            "answers": [
                "a) Recomandarea de a se ţine, în spaţiul indicat, pe Canalul Sulina",
                "b) Obligaţia de a se ţine în spaţiu indicat",
                "c) Recomandarea de a se ţine în spaţiul indicat"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "228. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-041.jpg",
            "answers": [
                "a) Căile întâlnite sunt considerate ca afluenţi ai căii urmate",
                "b) Obligaţia de a nu se angaja în calea principală sau de a nu traversa",
                "c) Calea urmată este considerată ca afluent al căii întâlnite"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "229. Priviţi cele două semnale de mai jos. Care este semnalul de obligaţie ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-042.jpg",
            "answers": [
                "a) Semnalul E",
                "b) Semnalul A",
                "c) Nici unul"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "230. Care sunt semnalele fonice de întâlnire prin babord, ce sunt emise atât de navele ce navigă amonte, cât şi de navele ce navigă aval ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Prima emite “un sunet scurt” nava care navigă aval. Nava care navigă amonte răspunde tot cu “un sunet scurt”",
                "b) Nava care navigă aval emite, “două sunete scurte”. Nava care navigă amonte răspunde cu “un sunet scurt”",
                "c) Nava care navigă amonte emite prima “un sunet scurt”. Nava care navigă aval răspunde cu “un sunet scurt” şi se abate din drum la dreapta"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "231. Atunci când o navă aflată în pericol vrea să ceară ajutor, ea poate să emită :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) “O serie de sunete de clopot”",
                "b) “O serie de cinci sunete lungi” la interval de un minut",
                "c) “O serie de sunete de clopot” sau “sunete lungi” cu alte mijloace acustice repetate"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "232. Nava care emite, “serie de sunete foarte scurte” ce semnalizează ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Este în imposibilitatea de manevră",
                "b) Este în pericol şi cere ajutor",
                "c) Este în pericol iminent de abordaj"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "233. Şcondri pentru stânga au culoarea :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Verde",
                "b) Neagră",
                "c) Roşie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "234. Ce semnificaţie are semnalul alăturat :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-043.jpg",
            "answers": [
                "a) Traversare de la malul stâng",
                "b) Traversarea de la malul drept",
                "c) Jalon de aliniament dreapta"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "235. Priviţi semnalul de mai jos. Ce semnificaţie are ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-044.jpg",
            "answers": [
                "a) Interzice trecerea",
                "b) Interzice trecerea prelungită",
                "c) Interzice orice deplasare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "236. Priviţi imaginea de mai jos. Ce semnificaţie are ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-045.jpg",
            "answers": [
                "a) Limitează şenalul",
                "b) Interzice trecerea în spaţiul indicat",
                "c) Intertice trecerea în afara spaţiului indicat"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "237. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-046.jpg",
            "answers": [
                "a) Obligaţia de a păstra o vigilenţă deosebită",
                "b) Obligaţia de a emite un semnal fonic",
                "c) Interzice emiterea semnalelor fonice"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "238. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-047.jpg",
            "answers": [
                "a) Trecerea interzisă în sensul indicat",
                "b) Trecerea recomandată în singurul sens indicat",
                "c) Trecerea recomandată în ambele sensuri"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "239. Care dinte cele două semnale de mai jos este semnal de indicaţie :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-048.jpg",
            "answers": [
                "a) Semnalul A 5",
                "b) Semnalul E 5",
                "c) Ambele semnale"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "240. Se pot folosi semnale fonice, altele decât cele prevăzute de R.N.D. ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu",
                "b) Numai pentru comunicări între nave sau între o navă şi uscat",
                "c) Da"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "241. Pentru a întoarce la babord o navă trebuie să emită :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) “Două sunete scurte” urmate de “un sunet lung”",
                "b) “Un sunet lung” urmat de “două sunete scurte”",
                "c) “Un sunet lung” urmat de “un sunet scurt”"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "242. O navă care staţionează în poziţie nesigură în condiţii de vizibilitate redusă emite :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) “O serie simplă de sunete de clopot” repetate la fiecare minut",
                "b) “O serie dublă de sunete de clopot” repetate la cel puţin fiecare minut",
                "c) “O serie triplă de sunete de clopot” repetate cel puţin la fiecare minut"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "243. Care este forma, culoarea şi care sunt caracteristicile unei geamanduri pentru stânga ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) De formă sferică piturată în negru-roşu- negru-roşu, lumina de culoare albă intermitentă",
                "b) De formă conică piturată în verde, lumina de culoare verde intermitentă",
                "c) De formă cilindrică piturată în roşu lumina de culoare roşie intermitentă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "244. Ce semnificaţie au semnalele din desenul alăturat ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-049.jpg",
            "answers": [
                "a) Far de intrare în bazin mal stâng",
                "b) Jaloane aliniament stâng",
                "c) Nici o semnificaţie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "245. Priviţi semnalul alăturat . Ce semnificaţie are ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-050.jpg",
            "answers": [
                "a) Interzice trecerea",
                "b) Interzice orice depăşite",
                "c) Interzice depăşirea numai dintre convoaie"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "246. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-051.jpg",
            "answers": [
                "a) Obligă navele de a se îndrepta spre partea şenalului care se găseşte la babord",
                "b) Obligă navele de a urma direcţia indicată prin săgeată",
                "c) Obligă navele de a se îndrepta spre partea şenalului care se găseşte la tribord"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "247. Care dintre obligaţiile de mai jos, vă revin când sunteţi de cart la comanda unei nave în marş şi întâlniţi semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-052.jpg",
            "answers": [
                "a) Înainte de a vă angaja în calea principală să emiteţi semnalele sonore prevăzute de R.N. D.",
                "b) Să nu vă angajaţi pe calea principală sau să nu traversaţi decât dacă manevra nu obligă, alte nave care navigă pe această cale să-şi modifice drumul sau viteza",
                "c) Nu aveţi nici o obligaţie, întrucât semnalul indică prioritate de trecere pentru dumneavoastră"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "248. Ce semnificaţie generală are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-053.jpg",
            "answers": [
                "a) Permitere de trecere",
                "b) Recomandare de trecere",
                "c) Interzicere de trecere"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "249. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-054.jpg",
            "answers": [
                "a) Căile întâlnite sunt considerate ca afluenţi ai căii urmate",
                "b) Obligaţia de a nu se angaja în calea principală sau de a nu traversa",
                "c) Calea urmată e considerată ca afluent a căii întâlnite"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "250. Care dintre cele două semnale alăturate este semnalul de indicaţie ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-055.jpg",
            "answers": [
                "a) Semnalul A 8",
                "b) Semnalul E 8",
                "c) Nici unul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "251. Ce obligaţii au navele care aud un semnal fonic emis de o altă navă care doreşte să întoarcă ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nici o obligaţie",
                "b) Atât cât este necesar şi posibil, să-şi modifice viteza  şi drumul lor pentru ca întoarcerea navei care a emis semnalul să se efectueze fără pericol",
                "c) Să se oprească în locul unde erau când au recepţionat semnalul fonic de rondou al unei alte nave"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "252. Cum semnalizează noaptea navele care sunt în pericol şi cer ajutor ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Agită circular o lumină",
                "b) Aprind o lumină roşie intermitentă",
                "c) Agită o lumină indiferent de culoare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "253. Emiterea de către o navă a “două sunete scurte” are semnificaţia de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Vin la tribord",
                "b) Voi întoarce la babord",
                "c) Vin la babord"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "254. Geamandurile de culoare verde cu lumină verde intermitentă balizează :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Partea stangă a şenalului şi pericolele  de la malul stâng",
                "b) Partea dreapta a şenalului şi pericolele de la malul drept",
                "c) Pericolele de navigaţie situate în şenal"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "255. Lumina de coastă (far) de pe malul stâng, are următoarele caracteristici :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Suport de culoare albă, lumină de culoare verde intermitentă şi un panou de formă rombică, piturat jumătate verde-partea de sus şi jumătate alb-partea de jos",
                "b) Suport de culoare albă, lumină de culoare verde intermitentă şi un panou dreptunghiular, piturat la partea superioară şi inferioară cu câte o dungă albă, iar între cele două dungi albe piturat cu roşu",
                "c) Suport de culoare albă, cu lumină de culoare roşie intermitentă şi un panou de formă rombică, piturat jumătate negru la partea superioară şi jumătate alb la partea inferioară"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "256. Ce indică semnalul alăturat ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-056.jpg",
            "answers": [
                "a) Puncte periculoase de la malul stâng",
                "b) Puncte periculoase de la malul drept",
                "c) Puncte periculoase în şenal"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "257. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-057.jpg",
            "answers": [
                "a) Interzicerea de a încrucişa şenalul la tribord",
                "b) Interzicerea oricărei încrucişări",
                "c) Obligaţia de a încrucişa şenalul la tribord"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "258. Ce semnificaţie are semnalul alăturat ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-058.jpg",
            "answers": [
                "a) Obligaţia de a reduce viteza",
                "b) Sunt impuse restricţii de navigaţie; informaţi-vă",
                "c) Obligaţia de a se opri în condiţiile prevăzute în R.N.D"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "259. Ce semnificaţie are semnalul alăturat ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-059.jpg",
            "answers": [
                "a) Bac care nu navigă liber",
                "b) Bac care navigă liber",
                "c) Bac"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "260. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-060.jpg",
            "answers": [
                "a) Loc de alimentare cu apă potabilă",
                "b) Apă potabilă",
                "c) Punct public de alimentare cu apă potabilă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "261. Care sunt semnalele fonice emise în cursul unei depăşiri prin tribord, atât de nava care ajunge din urmă, cât şi de nava ajunsă, care nu poate oferi drumul cerut, însă poate oferi depăşirea prin babord ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava care ajunge din urma emite “două sunete lungi” şi, “două sunete scurte”, nava ajunsă emite “două sunete scurte”",
                "b) Nava care ajunge din urmă emite, “două sunete lungi” şi “ două sunete scurte”, nava ajunsă emite “un sunet scurt”",
                "c) Nava care ajunge din urmă emite “două sunete lungi” şi “un sunet scurt”, nava ajunsă emite “un sunet scurt”"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "262. Atunci când o navă este în marş în convoi sau într-o formaţie în cuplu, semnalele fonice prevăzute de R.N.D vor fi emise de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava la bordul căreia se află conducătorul convoiului sau formaţiei",
                "b) Toate navele, în funcţie de situaţiile ivite",
                "c) Una din navele autopropulsate"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "263. Nava care emite “3 sunete scurte” :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Este în imposibilitate de a manevra",
                "b) Dă înapoi",
                "c) Vine la babord"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "264. Un convoi sau o formaţie în cuplu, în marş amonte, în condiţii de vizibilitate redusă emite :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) “Două sunete lungi”,  repetate cel puţin la fiecare minut",
                "b) “Un sunet lung”, repetat  la cel puţin două minute",
                "c) “Două sunete lungi” , repetate continuu"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "265. Geamandurile luminoase şi neluminoase, şcondri şi jaloanele pentru dreapta sau pentru stânga, în principiu ce marchează ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Limita şenalului şi pericolele de la malul respectiv",
                "b) Pericolele de navigaţie situate în şenal",
                "c) Pericolele de la malul respectiv"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "266. Lumina de coastă (far) de pe malul drept şi lumina de coastă (far) de pe malul stâng în principiu indică :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Pericolele din apropierea malurilor şi în acelaşi timp apropierea şenalului de maluri",
                "b) Direcţia aproximativă a şenalului în raport cu malul şi serveşte în acelaşi timp ca punct de reper",
                "c) Direcţia şenalului în raport cu pericolele de la maluri"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "267. Ce semnificaţie are semnalul alăturat ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-061.jpg",
            "answers": [
                "a) În zona respectivă sunt anafoare",
                "b) Interzicerea de a întoarce",
                "c) Indică locuri periculoase pentru întoarcerea navelor"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "268. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-062.jpg",
            "answers": [
                "a) Obligă navele să emita un sunet scurt",
                "b) Interzice emiterea de semnale sonore",
                "c) Obligă navele de a opri în condiţiile prevăzute în Regulamentul de Navigaţie pe Dunăre"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "269. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-063.jpg",
            "answers": [
                "a) Post telefonic",
                "b) Post telefonic numai în porturi",
                "c) Telefon public"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "270. Navele care sunt în pericol şi cer ajutor, ce semnal vizual arată ziua ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Agită un pavilion alb",
                "b) Agită circular un pavilion sau orice alt obiect asemănător",
                "c) Agită circular un balon roşu"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "271. Emiterea de către o navă a unui semnal fonic scurt, are semnificaţia de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Molaţi parâmele",
                "b) Întoarcere la tribord",
                "c) Vin la tribord"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "272. O navă care iese dintr-un bazin portuar sau dintr-un afluent şi se îndreaptă la babord emite:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Trei sunete lungi",
                "b) Un sunet lung urmat de două sunete scurte",
                "c) Trei sunete lungi urmate de două sunete scurte"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "273. Ce semnificaţie au geamandurile de culoare roşie cu lumina roşie intermitentă ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Marchează limitele şenalului şi direcţia sa balizând partea stângă a şenalului şi pericolele de la malul stâng",
                "b) Marchează limitele şenalului şi direcţia sa balizând partea dreaptă a şenalului şi pericolele de la malul drept",
                "c) Balizează pericolele de navigaţie situate în şenal"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "274. Lumina de coastă (far) de pe malul drept are următoarele caracteristici:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Suport de culoare albă, lumină de culoare verde intermitentă şi un panou pătrat roşu, mărginit de două benzi orizontale albe",
                "b) Suport de culoare albă, lumină de culoare roşie intermitentă şi un panou pătrat roşu, mărginit de două benzi orizontale albe",
                "c) Suport de culoare albă, lumină de culoare roşie intermitentă şi un panou pătrat verde mărginit de două benzi orizontale albe"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "275. Ce semnificaţie are semnalul alăturat ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-064.jpg",
            "answers": [
                "a) Arată conducătorilor de nave că încrucişarea este interzisă",
                "b) Obligă navele de a încrucişa şenalul la babord",
                "c) Interzice de a încrucişa şenalul la babord"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "276. Ce semnificaţie are semnalul alăturat ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-065.jpg",
            "answers": [
                "a) Lăţimea pasei de trecere este limitată",
                "b) Lăţimea şenalului este limitată",
                "c) Lăţimea pasei de trecere sau a şenalului este limitată"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "277. Ce semnificaţie are semnalul alăturat  ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-066.jpg",
            "answers": [
                "a) Garduri pescăreşti",
                "b) Baraj",
                "c) Reţea de înală tensiune"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "278. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-067.jpg",
            "answers": [
                "a) Sfârşitul unei obligaţii valabile pentru un singur fel de navigaţie",
                "b) Sfârşitul unei restricţii sau obligaţii",
                "c) Sfârşitul unei interziceri sau a unei obligaţii valabilă pentru un singur sens de navigaţie sau sfârşitul unei restricţii"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "279. Când o navă vrea să se folosească de prioritatea sa de trecere emite următorul semnal fonic :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un sunet lung, un sunet scurt, un sunet lung",
                "b) Nu este prevăzut în Regulamentul de Navigaţie pe Dunăre",
                "c) Un sunet scurt, unul lung, unul scurt"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "280. Cinci sunete scurte emise de o navă ajunsă din urmă înseamnă :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Pericol iminent de abordaj",
                "b) Imposibilitate de a depăşi",
                "c) Imposibilitate de manevră"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "281. O navă staţionând în partea stângă a şenalului în condiţii de vizibilitate redusă emite :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Bătăi de clopot repetate la fiecare minut",
                "b) O serie dublă de bătăi de clopot repetată cel puţin la fiecare minut",
                "c) O serie simplă de bătăi de clopot repetate cel puţin la fiecare minut"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "282. Ce semnificaţie au geamandurile luminoase şi neluminoase, şcondrii şi jaloanele de joncţiune şi de bifurcaţie ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Semnalizează numai joncţiunea şi bifurcaţia şenalului",
                "b) Balizează numai pericolele de navigaţie situate pe şenal",
                "c) Semnalizează joncţiunea şi bifurcaţia şenalului şi în afară de aceasta balizează pericolele de navigaţie din şenal"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "283. În principiu semnalele de mai jos indică :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-068.jpg",
            "answers": [
                "a) Începutul şi sfârşitul traversării şenalului de la un mal la altul",
                "b) Axa şenalului în raport cu malurile",
                "c) Direcţia pericolelor de navigaţie în raport cu malurile"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "284. Două panouri suprapuse, de forma şi culoarea din figura de mai jos, indică ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-069.jpg",
            "answers": [
                "a) Trecerea interzisă",
                "b) O interzicere prelungită de trecere",
                "c) Încrucişarea şi depăşirea sunt interzise"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "285. Ce semnificaţie are semnalul din imaginea alăturată  ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-070.jpg",
            "answers": [
                "a) Interzice navigaţia în direcţia indicată de săgeată",
                "b) Obligă pe conducătorii de nave de a urma direcţia indicată prin săgeată",
                "c) Indică direcţia unde se găsesc locuri sigure pentru staţionarea navelor"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "286. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-071.jpg",
            "answers": [
                "a) Obligaţia de a emite un semnal fonic",
                "b) Interzice emiterea semnalelor fonice",
                "c) Obligaţia de a păstra o vigilenţă deosebită"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "287. Ce semnificaţie are semnalul din imaginea alăturată  ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-072.jpg",
            "answers": [
                "a) Trecerea interzisă în sensul indicat",
                "b) Trecerea recomandată în singurul sens indicat",
                "c) Trecerea recomandată în ambele sensuri"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "288. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-073.jpg",
            "answers": [
                "a) Interzicerea de a efectua întoarcerea",
                "b) Obligaţia de a face întoarcerea",
                "c) Loc de întoarcere"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "289. Care din cele două semnale de mai jos crează obligaţii pentru conducătorii de nave ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-074.jpg",
            "answers": [
                "a) Semnalul A 6",
                "b) Semnalul B 6",
                "c) Nici unul"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "290. Semnalele fonice ale navelor autopropulsate sunt însoţite de semnale luminoase sincronizate cu acestea, având următoarele caracteristici :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Lumina de culoare galbenă obişnuită, vizibilă din toate părţile",
                "b) Lumina de culoare albă clară, vizibilă din toate părţile",
                "c) Lumina de culoare galbenă clară, vizibilă din toate părţile"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "291. O navă care iese dintr-un bazin şi vrea să traverseze calea navigabilă :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) \"Două sunete lungi\"",
                "b) \"Trei sunete lungi\"",
                "c) \"Un sunet lung\""
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "292. Care este forma, culoarea şi care sunt caracteristicile luminii unei geamanduri pentru dreapta ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) De formă sferică, piturată în negru–roşu- negru–roşu, lumina de culoare albă intermitentă",
                "b) De formă conică, piturată în negru, lumina de culoare verde intermitentă",
                "c) De formă cilindrică, piturată în roşu, lumina de culoare roşie intermitentă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "293. Jaloanele de aliniament indică :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Axa traversării",
                "b) Pericolele de navigaţie de la malul drept sau stâng",
                "c) Începutul sau sfârşitul traversării şenalului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "294. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-075.jpg",
            "answers": [
                "a) Interzicerea încrucişării",
                "b) Interzicerea depăşirii",
                "c) Interzicerea de înâlnire şi depăşire"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "295. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-076.jpg",
            "answers": [
                "a) Interzicerea oricărei încrucişări şi depăşiri",
                "b) Obligă navele de a ţine partea şenalului care se găseşte la babord",
                "c) Obligă navele de a efectua încrucişarea în zona unde este amplasat semnalul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "296. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-077.jpg",
            "answers": [
                "a) Adâncimea apei este limitată",
                "b) Albia prezintă mameloane",
                "c) Asiguraţi-vă ! Sunt depuneri masive"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "297. Ce semnificaţie are semnalul din imaginea ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-078.jpg",
            "answers": [
                "a) Obligaţia de a se îndrepta în sensul săgeţii",
                "b) Recomandarea de a se îndrepta în sensul săgeţii",
                "c) Indică direcţia unde se recomandă staţionarea"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "298. Ce semnificaţie are semnalul din imaginea alăturată  ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-079.jpg",
            "answers": [
                "a) Calea urmată este considerată ca afluent al căii întâlnite",
                "b) Căile întâlnite sunt considerate ca afluenţi ai căii urmate",
                "c) Obligaţia de a nu se angaja în calea principală sau de a nu traversa"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "299. Care dintre cele două semnale crează obligaţii pentru conducătorii de nave ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-080.jpg",
            "answers": [
                "a) Semnalul B 1",
                "b) Semnalul D 3",
                "c) Ambele semnale"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "300. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-081.jpg",
            "answers": [
                "a) Interzicerea navigaţiei navelor cu două elici",
                "b) Interzicerea navigaţiei navelor autopropulsate",
                "c) Interzicerea navigaţiei navelor nepropulsate"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "301. Ce semnificaţie are semnalul din imaginea alăturată  ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-082.jpg",
            "answers": [
                "a) Interzicerea sporturilor nautice",
                "b) Interzicerea de staţionare a navelor de sport şi agrement",
                "c) Interzicerea navigaţiei pentru toate ambarcaţiuni de sport şi agrement"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "302. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-083.jpg",
            "answers": [
                "a) Interzicerea practicării schiului nautic",
                "b) Interzicerea practicării sporturilor nautice",
                "c) Interzicerea oricăror nave de a tracta persoane care practică schiul nautic"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "303. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-084.jpg",
            "answers": [
                "a) Interzicerea navigaţiei navelor cu vele",
                "b) Interzicerea navigaţiei navelor cu vele cu un tonaj mai mare de 50 de tone",
                "c) Interzicerea staţionării navelor cu vele"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "304. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-085.jpg",
            "answers": [
                "a) Interzicerea de a lăsa ambarcaţiuni cu rame la apă",
                "b) Interzicerea staţionării ambarcaţiunilor cu rame pe partea şenalului pe care este amplasat semnalul",
                "c) Interzicerea navigaţiei navelor care nu sunt autopropulsate şi nici cu vele"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "305. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-086.jpg",
            "answers": [
                "a) Permiterea de staţionare a navelor autopropulsate",
                "b) Permiterea de a face probe la paratul plutitor",
                "c) Permiterea navigaţiei pentru navele autopropulsate"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "306. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-087.jpg",
            "answers": [
                "a) Permiterea navigaţiei pentru ambarcaţiuni de sport sau agrement",
                "b) Permiterea practicării sporturilor nautice",
                "c) Zona indicată staţionării navelor de sport şi agrement"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "307. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-088.jpg",
            "answers": [
                "a) Obligaţia de a practica schiul nautic",
                "b) Permiterea de a practica schiul nautic",
                "c) Permiterea navigaţiei navelor ce tractează persoane care practică schiul nautic"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "308. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-089.jpg",
            "answers": [
                "a) Permiterea staţionării navelor cu vele",
                "b) Permiterea navigaţiei pentru navele cu vele",
                "c) Permiterea practicării sporturilor nautice"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "309. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-090.jpg",
            "answers": [
                "a) Recomandarea de a lăsa bărci la apă",
                "b) Permiterea navigaţiei pentru navele care nu sunt nici autopropulsate nici cu vele",
                "c) Permiterea de staţionare a navelor cu rame pe partea unde este amplasat semnalul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "310. Care sunt considerate materiale inflamabile în sensul Regulamentului de Navigaţie pe Dunăre ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Lichidele combustibile ce se pot amesteca cu apa în orice fel",
                "b) Hidrocarburile şi combustibilii lichizi cu punctul de inflamabilitate inferior sau egal cu 100 grade C la o înălţime barometrică de 760 mm coloană de mercur",
                "c) Hidrocarburile şi combustibilii lichizi cu punctul de inflamabilitate superior cu 100 grade C la o înălţime barometrică de 700 mm coloană de mercur"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "311. Care sunt considerate materiale explozibile în sensul Regulamentului de Navigaţie pe Dunăre ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Materiale şi obiecte explozibile atunci când greutatea lor brută totală este mai mică de 5 kg",
                "b) Materiale şi obiecte explozibile atunci când greutatea lor brută totală este mai mare de 5 kg",
                "c) Tuburi de cartuşe încărcate şi cartuşe pentru arme de foc portative când greutatea lor brută totală este mai mare de 5 kg"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "312. Lichidele, combustibile într-o cantitate ce nu depăşeşte 200 l şi transportate în colete sunt considerate materiale inflamabile ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu este prevăzut în Regulamentul de Navigaţie pe Dunăre",
                "b) Da",
                "c) Nu"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "313. Amoniacul lichefiat sau dizolvat sub presiune când este transportat în nave cisternă (tancuri) este considerat material exploziv ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu este prevăzut în Regulamentul de Navigaţie pe Dunăre",
                "b) Nu",
                "c) Da"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "314. Sulfura de carbon în stare lichidă este considerată material inflamabil ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu",
                "b) Nu este prevăzut în Regulamentul de Navigaţie pe Dunăre",
                "c) Într-o cantitate mai mare de 2 kg"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "315. Ce greutate brută totală trebuie să aibă aprinzătoarele, piesele de artificii pentru a fi considerate materiale explozibile ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Mai mare de 15 kg",
                "b) 10 kg",
                "c) 5 kg"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "316. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-091.jpg",
            "answers": [
                "a) Emiterea unui sunet lung",
                "b) Vigilenţă deosebită",
                "c) Oprirea la 1000 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "317. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-092.jpg",
            "answers": [
                "a) Interzicerea staţionării (pe o distanţă de 1000 m)",
                "b) Interzicerea staţionării (pe o distanţă mai mare de 1000 m)",
                "c) Ancorarea interzisă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "318. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-093.jpg",
            "answers": [
                "a) Punct de control trecere frontieră",
                "b) Opriţi pentru vamă !",
                "c) Punct vamal"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "319. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-094.jpg",
            "answers": [
                "a) Interzicerea navigaţiei pe scândura cu vele",
                "b) Interzisă practicarea sporturilor nautice",
                "c) Interzisă practicarea surfingului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "320. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-095.jpg",
            "answers": [
                "a) Interzicerea de navigaţie a şalupelor",
                "b) Terminarea zonei permise pentru navigaţia cu viteza mare a ambarcaţiunilor mici de sport sau de agrement",
                "c) Interzicerea de întâlnire a şalupelor"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "321. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-096.jpg",
            "answers": [
                "a) Interzicerea de a lăsa la apă sau de a ridica pe mal ambarcaţiuni",
                "b) Interzicerea de a naviga cu ambarcaţiuni mici",
                "c) Interzicerea de a ridica pe mal ambarcaţiuni"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "322. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-097.jpg",
            "answers": [
                "a) Obligaţia de a intra în legătură radiotelefonică",
                "b) Interzicerea de a intra în legătură radiotelefonică",
                "c) Recomandarea de a intra în legătură radiotelefonică"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "323. Ce semnificaţie au semnalele luminoase din imaginea de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-098.jpg",
            "answers": [
                "a) Obligaţia navelor care navigă pe calea principală să schimbe, în caz de nevoie, drumul sau viteza lor pentru a ceda drumul navelor care ies din port sau din calea afluentă",
                "b) Interzicerea navelor care navigă pe calea principală să schimbe drumul sau viteza lor pentru a ceda drumul navelor care ies din port sau din calea afluentă",
                "c) Obligaţia navelor care navigă pe calea afluentă să schimbe drumul în caz de nevoie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S3",
            "difficulty": 1
        },
        {
            "question": "324. Navigaţia la trecerea pe sub podul GIURGENI-VADU OII, pentru marşul amonte/aval, se desfăşoară :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Print-o singură deschidere",
                "b) Prin două deschideri separate",
                "c) Confom ordinelor date de Punct control Hârşova"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "325. Navigaţia la trecerea pe sub podul GIURGENI-VADU OII, din amonte spre aval, se desfăşoară :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Prin deschiderea centrală",
                "b) Prin deschiderea de la malul drept",
                "c) Prin deschiderea de la malul stâng"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "326. Navigaţia la trecerea pe sub podul GIURGENI-VADU OII, din aval spre amonte, se desfăşoară :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Prin deschiderea centrală",
                "b) Prin deschiderea de la malul drept",
                "c) Prin deschiderea de la malul stâng"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "327. Pe timp de ceaţă sau noapte cu vizibilitate redusă, se interzice trecerea, pe sub podul GIURGENI-VADU OII, navelor şi convoaielor care nu au la bord :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Radar în stare bună de funcţionare",
                "b) Echipajul minim de siguranţă",
                "c) Instalaţia de stins incendiu şi salvare în stare bună"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "328. Se interzice orice trecee pe sub podul GIURGENI-VADU OII în caz de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Vânt puternic sau furtună",
                "b) Trafic aglomerat de nave",
                "c) Valuri"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "329. Lăţimea şenalului, prin deschiderea centrală a podului GIURGENI-VADU OII, este de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 120 m",
                "b) 100 m",
                "c) 90 m"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "330. Lăţimea şenalului, prin deschiderea de la malul stâng a podului GIURGENI-VADU OII, este de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 120 m",
                "b) 100 m",
                "c) 90 m"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "331. Convoaiele împinse care navigă în amonte, la trecerea pe sub podul GIURGENI-VADU OII, pot fi formate maxim din cel mult :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Trei dane a trei unităţi în dană",
                "b) Două dane a patru unităţi în dană",
                "c) Trei dane a patru unităţi în dană"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "332. Convoaiele împinse care navigă în aval, la trecerea pe sub podul GIURGENI-VADU OII, pot fi formate din două dane a câte patru unităţi în dană ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Numai cu aprobarea Căpităniei portului Hârşova"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "333. La trecerea pe sub podul GIURGENI-VADU OII, remorcherele trebui să-şi reducă remorca, pentru navigaţia în amonte, la cel mult :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 120 m",
                "b) 100 m",
                "c) 60 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "334. La trecerea pe sub podul GIURGENI-VADU OII, remorcherele trebui să-şi reducă remorca, pentru navigaţia în aval, la cel mult:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 100 m",
                "b) 60 m",
                "c) 30 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "335. La trecerea pe sub podul GIURGENI-VADU OII, legăturile între dane, la convoaiele remorcate, trebui să fie de cel mult :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 60 m",
                "b) 30 m",
                "c) 15 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "336. Ce cantitate de marfă/CP nu trebui să depăşească convoaiele împinse la trecerea pe sub podul GIURGENI-VADU OII ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 8 tone marfă / CP",
                "b) 6 tone marfă / CP",
                "c) 4 tone marfă / CP"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "337. Ce cantitate de marfă / CP nu trebui să depăşească convoaiele remorcate la trecerea pe sub podul GIURGENI-VADU OII ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 8 tone marfă / CP",
                "b) 6 tone marfă / CP",
                "c) 4 tone marfă / CP"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "338. Navigaţia la trecerea pe sub podurile de la CERNAVODĂ, pentru marşul amonte / aval, se desfăşoară :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Printr-o singură deschidere",
                "b) Prin două deschideri separate",
                "c) Confom ordinelor date de Căpitănia portului Cernavodă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "339. Navigaţia pe Dunăre în zona podurilor de la CERNAVODĂ se desfăşoară prin :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Deschiderea centrală",
                "b) Deschiderea de la malul drept",
                "c) Deschiderea de la malul stâng"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "340. Prioritatea de trecere, pe sub podurile de la CERNAVODĂ, o au navele care :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Navigă dinspre amonte spre aval",
                "b) Navigă dinspre aval spre amonte",
                "c) Sunt stabilite de Căpitănia portului Cernavodă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "341. La trecerea pe sub podurile de la CERNAVODĂ, remorcherele trebui să-şi reducă remorca, pentru navigaţia în amonte, la cel mult :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 60 m",
                "b) 45 m",
                "c) 30 m"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "342. La trecerea pe sub podurile de la CERNAVODĂ, remorcherele trebui să-şi reducă remorca, pentru navigaţia în aval, la cel mult :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 45 m",
                "b) 30 m",
                "c) 25 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "343. Lăţimea maximă a şenalului prin deschiderile centrale ale podurilor de la CERNAVODĂ este de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 180 m",
                "b) 155 m",
                "c) 120 m"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "344. Pe timp de ceaţă sau noapte cu vizibilitate redusă se interzice trecerea, pe sub podurile de la CERNAVODĂ, navelor şi convoaielor care nu au la bord :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Radar în stare bună de funcţionare",
                "b) Echipajul minim de siguranţă",
                "c) Instalaţia de semnalizare fonică şi luminoasă în stare bună"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "345. Se interzice orice trecere pe sub podurile de la CERNAVODĂ în caz de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Valuri",
                "b) Ploaie",
                "c) Vânt puternic sau furtună"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "346. Pentru nivelul de apă situat peste cota +150 cm Cernavodă, convoaiele împinse, care trec pe sub porudile de la Cernavodă vor fi formate, în sensul aval, maxim din :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Două dane a patru unităţi în dană",
                "b) Trei dane a patru unităţi în dană",
                "c) Patru dane a patru unităţi în dană"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "347. Pentru nivelurile situate între cota +150 cm şi ±0,00 cm Cernavodă, convoaiele împinse, care trec pe sub podurile de la CERNAVODĂ, vor fi formate, în sensul aval, maxim din :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Două dane a patru unităţi în dană",
                "b) Două dane a trei unităţi în dană",
                "c) Trei dane a trei unităţi în dană"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "348. Pentru nivelurile situate sub cota ±0,00 cm Cernavodă, convoaiele, la trecerea pe sub podurile de la CERNAVODĂ, atât pentru navigaţia în amonte cât şi pentru navigaţia în aval, vor avea în formaţii maxim :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Două dane a câte două unităţi în dană",
                "b) Două dane a câte trei unităţi în dană",
                "c) Trei dane a câte trei unităţi în dană"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "349. Navigaţia pe Braţul Borcea, în zona podurilor de la FETEŞTI, pentru marşul amonte/aval, se desfăşoară :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Print-o singură deschidere",
                "b) Prin două deschideri separate",
                "c) Conform ordinelor date de Căpitănia portului Feteşti"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "350. Navigaţia pe Braţul Borcea, în zona podurilor de la FETEŞTI, din amonte spre aval, se desfăşoară :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Prin deschiderea centrală",
                "b) Prin deschiderea de la malul drept",
                "c) Prin deschiderea de la malul stâng"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "351. Navigaţia pe Braţul Borcea, în zona podurilor de la Feteşti, din aval spre amonte, se desfăşoară :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Prin deschiderea centrală",
                "b) Prin deschiderea de la malul drept",
                "c) Prin deschiderea de la malul stâng"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "352. Pe timp de ceaţă sau noapte cu vizibilitate redusă, se interzice trecerea, pe sub podurile de la FETEŞTI, navelor şi convoaielor care nu au la bord :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Radar în stare bună de funcţionare",
                "b) Echipajul minim de siguranţă",
                "c) Instalaţii de guvernare în stare bună"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "353. Se interzice orice trecere pe sub podurile de la FETEŞTI în caz de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Vânt puternic sau furtună",
                "b) Ceaţă",
                "c) Ploaie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "354. Lăţimea şenalului, prin deschiderile de la malul stâng a podurilor de la FETEŞTI, este de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 150 m",
                "b) 100 m",
                "c) 90 m"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "355. Lăţimea şenalului, prin deschiderile centrale a podurilor de la FETEŞTI, este de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 150 m",
                "b) 100 m",
                "c) 90 m"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "356. Pentru nivelurile de apă situate peste cota +150 cm Cernavodă, convoaiele care navigă spre amonte pe sub podurile de la FETEŞTI, vor fi formate maxim din :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Două dane a câte trei unităţi în dană",
                "b) Două dane a câte patru unităţi în dană",
                "c) Trei dane a câte trei unităţi în dană"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "357. La trecerea pe sub podurile de la FETEŞTI, peste cota +150 cm Cernavodă, convoaiele împinse în marş aval, pot naviga şi în formaţie de o singură dană cu patru unităţi în dană ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Numai cu aprobarea Căpităniei portului Feteşti"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "358. La trecerea pe sub podurile de la FETEŞTI, pentru nivelurile de apă la cota +150 cm Cernavodă sau mai mici, convoaiele împinse care navigă în amonte, vor fi formate maxim din :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Două dane a câte trei unităţi în dană",
                "b) Două dane a câte patru unităţi în dană",
                "c) Trei dane a câte trei unităţi în dană"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "359. La trecerea pe sub podurile de la FETEŞTI, pentru nivelurile de apă la cota +150 cm Cernavodă sau mai mici, convoaiele împinse care navigă în aval, vor fi formate maxim din :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Două dane a câte trei unităţi în dană",
                "b) Două dane a câte două unităţi în dană",
                "c) Trei dane a câte două unităţi în dană"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "360. La trecerea pe sub podurile de la FETEŞTI, pentru nivelurile de apă la cota +150 cm Cernavodă sau mai mici, convoaiele împinse în marş aval, pot naviga şi în formaţie de o singură dană cu patru unităţi în dană ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Numai cu aprobarea Căpităniei portului Feteşti"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "361. La trecerea pe sub podurile de la FETEŞTI, remorcherele trebui să-şi reducă remorca, pentru navigaţia în amonte, la cel mult :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 100 m",
                "b) 60 m",
                "c) 45 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "362. La trecerea pe sub podurile de la FETEŞTI, remorcherele trebui să-şi reducă remorca, petnru navigaţia în aval, la cel mult :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 60 m",
                "b) 30 m",
                "c) 25 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "363. La trecerea pe sub pdurile de la FETEŞTI, legăturile dintre dane, la convoaiele remorcate, trebui să fie de cel mult :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 30 m",
                "b) 20 m",
                "c) 15 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "364. La trecerea pe sub podurile de la CERNAVODĂ, legăturile dintre dane, la convoaiele remorcate, trebui să fie de cel mult :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 60 m",
                "b) 30 m",
                "c) 15 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "365. Lăţimea şenalului navigabil prin deschiderile laterale ale podului GIURGIU-RUSSE este de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 150 m",
                "b) 120 m",
                "c) 100 m"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "366. Lăţimea şenalului navigabil prin deschiderea centrală la podul GIURGIU-RUSSE este de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 100 m",
                "b) 90 m",
                "c) 60 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "367. Pentru a obţine ridicarea traveei mobile, la podul GIURGIU-RUSSE, se solicită o cerere de trecere în timp :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Cel puţin o oră înainte de ora pentru care se solicită trecerea",
                "b) Cel puţin două ore înainte de ora pentru care se solicită trecerea",
                "c) Cel puţin cinci ore înainte de ora pentru care se solicită trecerea"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "368. Dacă în curs de o oră de la ridicarea traveei mobile, la podul GIURGIU-RUSSE, nava care a solicitat ridicarea nu a trecut, traveea mobilă poate fi coborâtă în poziţia sa normală ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Numai cu aprobarea Căpităniei portului Giurgiu"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "369. O navă ce navigă aval cu radarul în funcţiune în condiţii de vizibilitate redusă începe să emită semnalul sonor de trei sunete cu tonalităţi diferite numai când :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Pe ecranul radarului apar nave a căror poziţie sau comportare ar putea provoca o situaţie periculoasă",
                "b) Când se apropie de un sector în care s-ar putea găsi nave care încă nu sunt vizibile",
                "c) Pe ecranul radiolocatorului apar nave a căror poziţie sau comportare ar putea provoca o situaţie periculoasă şi când nava se apropie de un sector în care s-ar putea găsi nave care nu sunt încă vizibile pe ecran"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "370. În caz de întâlnire sau de depăşire navele care urmează drumuri ce exclud orice pericol de abordaj trebuie :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să-şi modifice drumul lor, astfel încât să nu apară pericol de abordaj",
                "b) Să nu-şi modifice drumul lor, astfel încât să apară pericol de abordaj",
                "c) Să se înţeleagă numai cu semnalizarea optică"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "371. Este interzisă întâlnirea în locurile în care şenalul nu prezintă o lăţime suficientă ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu",
                "b) Întâlnirea trebuie evitată în măsura posibilităţilor",
                "c) Nu este prevăzut în R.N.D."
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "372. Când sunt obligate navele care părăsesc locul lor de ancorare sau de acostare, fără a întoarce sau care traversează calea navigabilă, cu excepţia bacurilor să emită semnalele fonice ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) În orice situaţie",
                "b) Dacă în zona de unde pleacă navele, există obligativitatea de a emite un semnal fonic",
                "c) Dacă manevra intenţionată a se face trebui să oblige celelalte nave a se îndepărta din drumul lor sau de a-şi modifica viteza"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "373. Ce putere trebui să aibă navele autopropulsate, care propulsează un convoi sau o formaţie în cuplu ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu este prevăzut în R.N.D.",
                "b) Conform celor stabilite de Registru Naval Român",
                "c) O putere suficientă pentru a asigura o bună manevrabilitate a convoiului sau a formaţiei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "374. Navele care navigă cu radar şi observă pe ecran nave a căror poziţie sau mişcare pot provoca o situaţie de pericol şi care nu răspund la radiotelefon, trebuie să ia măsuri din timp pentru evitarea abordajului ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu",
                "b) Da",
                "c) NU este prevăzut expres în R.N.D."
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "375. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-099.jpg",
            "answers": [
                "a) Locuri de staţionare general recomandate, unde staţionarea la ancoră este permisă pe partea căii unde este instalat semnalul cu excepţia navelor ce transportă materiale inflamabile sau explozibile",
                "b) Permiterea de a ancora şi de a lăsa să se târască parâme sau lanţuri",
                "c) Obligaţia de a ancora"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "376. Ambarcaţiunile mici, care cedează drumul altor ambarcaţiuni mici, de regulă, trebuie să se abată din timp spre :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Babord",
                "b) Tribord",
                "c) Nu este prevăzut expres în R.N.D."
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "377. Noaptea, navele care navigă în amonte şi lasă drum liber la tribord navelor care navigă în aval, trebuie, în timp util :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să arate la tribord o lumină albă, puternică, intermitentă, vizibilă din prova",
                "b) Să arate la babord o lumină albă, clară, intermitentă, vizibilă din prova şi, pe cât posibil şi din pupa",
                "c) Să arate la tribord o lumină albă, clară, intermitentă, vizibilă din prova şi, pe cât posibil, şi din pupa"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "378. Care este obligativitatea unei nave care navigă în aval, atunci, când constată că o navă care navigă amonte s-a angajat într-o trecere îngustă ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să atenţioneze, prin semnale fonice, nava care navigă amonte, să-i cedeze drumul",
                "b) Să atenţioneze nava care navigă amonte prin semnale fonice, să elibereze, în termenul cel mai scurt, trecerea îngustă",
                "c) În măsura în care este posibil să oprească în amonte de trecerea îngustă, până când nava care navigă amonte a trecut-o"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "379. Este admis navelor cu excepţia celor de supraveghere, de a acosta sau de a se agăţa de navele aflate în marş?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu",
                "b) Da. Numai cu autorizaţia expresă a conducătorului navei sau convoiului aflat în marş",
                "c) În R.N.D. nu este prevăzută această situaţie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "380. Este permisă trecerea simultană într-o deschidere de pod ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Numai dacă şenalul are o lăţime suficientă",
                "c) Nu"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "381. Navele cu aripi portante sunt obligate să lase spaţiul necesar tuturor celorlalte nave pentru continuarea navigaţiei acestora ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bis Nu este prevăzut expres în R.N.D.",
                "b) Da sunt obligate",
                "c) Nu"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "382. Când nu se emit semnale fonice de către nava ce ajunge din urmă, în cazul unei depăşiri ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Când nava ajunsă din urmă nu este nevoită să-şi modifice drumul",
                "b) Când nava ajunsă din urmă observă manevra de depăşire şi îşi modifică drumul",
                "c) În cazul depăşirii unui convoi de către o navă izolată în marş, numai ziua"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "383. Când nava care vrea să se întoarcă nu este obligată să emite semnale fonice ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Când navele din zonă nu sunt obligate să-şi modifice brusc drumul sau viteza, datorită rondoului navei care vrea să întoarcă",
                "b) Când întoarcerea se face într-un loc semnalizat pentru recomandarea de întoarcere, chiar dacă sunt şi alte nave în zonă",
                "c) În toate cazurile, nava care doreşte să întoarcă este obligată să emită semnale fonice, înainte de începerea întoarcerii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "384. Când nu se aplică interzicerea de a anviga în derivă ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) În cazul micilor mişcări la locurile de staţionare şi în cazul manevrelor",
                "b) Când şenalul are o lăţime absolut suficientă, iar adâncimile trec de 6 m",
                "c) Interzicerea de a naviga în derivă se aplică în toate cazurile"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "385. Ce viteză trebuie să adopte navele (convoaiele) care navigă în condiţii de vizibilitate redusă ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) \"viteză redusă\"",
                "b) \"viteza de siguranţă\"",
                "c) viteza la \"încet\""
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "386. Navele care merg în aval, navigând cu radar, pe timp de vizibilitate redusă emit :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) “Două sunete lungi” repetate la cel puţin un minut fiecare",
                "b) “Trei sunete de tonalităţi diferite” care se succed fără întrerupere",
                "c) “Un sunet lung” repetat la cel puţin fiecare minut"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "387. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-100.jpg",
            "answers": [
                "a) Locuri de staţionare speciale recomandate unde staţionarea prin legare este permisă pe partea căii unde este amplasat semnalul",
                "b) Locuri de staţionare generale recomandate, unde staţionarea prin legare este permisă la ambele maluri din zona de amplasare a semnalului",
                "c) Permitere de a se lega la mal"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "388. Cine cedează drumul în cazul întâlnirii dintre ambarcaţiunile mici nepropulsate care nu navigă cu vele şi ambarcaţiunile mici care navigă cu vele ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bis p.3 Ambarcaţiunile mici care navigă cu vele",
                "b) Ambarcaţiunile mici nepropulsate şi care nu navigă cu vele",
                "c) Nu se prevede expres în Regulamentul de Navigaţie pe Dunăre"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "389. Până când se arată semnalele pentru întâlnirea prin tribord ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Până când întâlnirea s-a efectuat",
                "b) Până când nava care navigă amonte s-a abătut din drumul navei care navigă aval",
                "c) Până când nava care navigă în aval a răspuns la semnele arătate de nava care navigă în amonte"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "390. În cazul în care întâlnirea într-o trecere îngustă a devenit inevitabilă, care sunt obligaţiile navelor care navigă amonte şi aval ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Ambele nave, înainte de efectuarea întâlnirii prin înţelegere vor face întâlnirea numai prin tribord",
                "b) Ambele nave trebuie să ia toate măsurile posibile pentru ca întâlnirea să se facă într- un loc şi în condiţii care să prezinte un minimum de pericol. Dacă se constată pericol de abordaj să se emită o serie de sunete foarte scurte",
                "c) Este interzisă cu desăvârşire întâlnirea în trecerile înguste"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "391. În cazul când depăşirea ne este posibilă fără pericol de abordaj nava ajunsă din urmă este obligată să emită :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) \"O serie de sunete foarte scurte\"",
                "b) \"5 sunete scurte\"",
                "c) \"Bătăi de clopot\" repetate"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "392. Este admisă navigaţia la aceeaşi înălţime a navelor sau convoaielor ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu",
                "b) Da, numai cu nave izolate",
                "c) Da, numai dacă şenalul are o lăţime absolut suficientă ţinându-se cont de toate împrejurările locale şi mişcările celorlalte nave"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "393. Este obligatorie utilizarea apărătorilor în ecluze ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu se prevede în R.N.D.",
                "b) Nu",
                "c) Da"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "394. Ambarcaţiunile mici care cedează drumul altor ambarcaţiuni mici pot face încrucişarea şi prin babord :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bis p.3 Nu",
                "b) Da",
                "c) Nu este prevăzut expres în R.N.D."
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "395. Care sunt semnalele fonice emise, atât de navele care navigă în amonte, cât şi de navele care navigă în aval, în cazul întâlnirii prin tribord ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava care navigă aval emite prima “două sunete scurte”. Nava care navigă amonte răspunde tot prin “două sunete scurte”",
                "b) Nava care navigă amonte emite prima “două sunete scurte”. Nava care navigă aval răspunde tot cu “două sunete scurte” şi se îndreaptă la stânga",
                "c) Nava care navigă amonte emite prima “două sunete scurte”. Nava care navigă aval răspunde cu “un sunet scurt” şi se abate la stânga"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "396. Când este obligatorie emiterea semnalelor fonice în cazul depăşirilor între nave sau convoaie ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Când depăşirile se fac între convoaie în timpul nopţii",
                "b) Când depăşirile se fac la trecerea prin puncte de lucru sau pe lângă nave la ancoră",
                "c) Când depăşirea nu poate avea loc fără ca nava ajunsă să nu se abată din drumul său"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "397. Navele care se lasă să coboare cu prova în amonte, cu maşina înainte, sunt considerate :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Ca navigând în derivă",
                "b) Ca navigând în amonte",
                "c) Nu este prevăzut în R.N.D."
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "398. Navele care navigă izolat, fără radar, în condiţii de vizibilitate redusă trebuie :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să aibă un post de radiotelefonie în funcţiune, aprobat de autorităţile competente un observator la prova ale cărui semnale trebuie să fie văzute sau auzite de conducătorul navei; viteza de siguranţă; să emită semnale fonice regulamentare",
                "b) Să navige cu viteza redusă cât mai aproape de mal; să emită semnalele fonice regulamentare",
                "c) Să reducă viteza la “jumătate” şi să emită semnalele fonice regulamentare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "399. O navă izolată, în marş amonte, în condiţii de vizibilitate redusă emite :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) “Două sunete lungi” repetate cel puţin la fiecare minut",
                "b) “Un sunet lung” repetat cel puţin la fiecare minut",
                "c) “Un sunet lung” repetat la fiecare două minute"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "400. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-101.jpg",
            "answers": [
                "a) Interzice a se lega la mal pe partea căii unde este amplasat",
                "b) Interzice legarea navelor de semnalele căii navigabile",
                "c) Interzice legarea în zona ambelor maluri"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "401. Ambarcaţiunile mici care navigă izolat şi convoaiele remorcate sau formaţiile în cuplu compuse numai din ambarcaţiuni mici, sunt obligate :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să nu jeneze mişcările şi manevrele celorlalte nave",
                "b) Să traverseze calea navigabilă numai în porturi",
                "c) Să navige numai ziua"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "402. Nava care navigă amonte şi lasă drum liber la babord navelor care navigă în aval, este obligată să emită vreun semnal ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu este prevăzut expres în R.N.D.",
                "b) Da",
                "c) Nu"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "403. Toate navele trebuie să treacă în timpul cel mai scurt posibil trecerile înguste ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu",
                "b) Nu este prevăzut în R.N.D.",
                "c) Da"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "404. Când sunt obligate navele care doresc să intre sau să iasă în / din bazinele portuare, să emită semnalele fonice prevăzute în R.N.D. în asemenea situaţii ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Când la ieşirea din bazin nu sunt instalate staţii semaforice de reglementare a ieşirii navelor",
                "b) După ce s-au asigurat că manevra respectivă poate fi efectuată fără pericol şi fără ca celelalte nave să fie obligate să-şi modifice drumul sau viteza",
                "c) Dacă manevra intenţionată obligă celelalte nave să-şi modifice drumul sau viteza"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "405. Este permisă navigaţia bacurilor pe cablu longitudinal ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu ste prevăzut în R.N.D.",
                "c) Nu"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "406. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-102.jpg",
            "answers": [
                "a) Permiterea de a staţiona în ancoră sau legat la mal pe partea unde este amplasat semnalul",
                "b) Permiterea sau recomandarea de a acosta la mal pe partea căii unde este amplasat semnalul",
                "c) Obligaţia de a staţiona pe partea căii unde este amplasat semnalul"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "407. Cine cedează drumul în cazul întâlnirii dintre două ambarcaţiuni mici ? (Din care una este autopropulsată şi cealaltă nepropulsată)",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bis p.3 Ambarcaţiunea autopropulsată",
                "b) Ambarcaţiunea nepropulsată",
                "c) Ambele, după ce în prealabil sau înţeles prin semnale"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "408. Ziua, navele care navigă în amonte şi lasă drum liber la tribord navelor care navigă în aval trebuie în timp util :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să arate la tribord o lumină albă intermitentă, obişnuită sau să agite la tribord un pavilion alb, ambele vizibile pe cât posibil numai din prova",
                "b) Să aibă la babord o lumină intermitentă sau să agite la babord un pavilion albastru, ambele vizibile din prova şi pe cât posibil din pupa",
                "c) Să arate la tribord o lumină albă puternică intermitentă sau să agite la tribord un pavilion sau un panou albastru deschis. Acestea să fie vizibile din prova şi pe cât posibil şi din pupa"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "409. Care este obligaţia unei nave care navigă amonte, atunci când constată că o navă care navigă aval este pe punctul de a se angaja într- o trecere îngustă ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să oprească în aval de această trecere până când nava care navigă aval a trecut-o",
                "b) Să facă rondou, să ancoreze şi să aştepte pănă trece nava ce navigă aval",
                "c) Să atenţioneze prin semnale fonice nava care navigă aval, să nu se angajeze în trecerea îngustă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "410. Care sunt semnalele fonice emise în cazul când se cere depăşirea prin tribord de către nava care ajunge din urmă, dacă nava ajunsă nu poate oferi depăşirea cerută, însă oferă depăşirea prin partea opusă şi nava care ajunge din urmă este de acord ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava care ajunge din urmă emite două semnale lungi şi două semnale scurte. Nava ajunsă emite două semnale scurte. Nava care ajunge din urmă răspunde cu un semnal scurt",
                "b) Nava care ajunge din urmă emite două semnale lungi şi un semnal scurt. Nava ajunsă emite un semnal scurt. Nava care ajunge din urmă răspunde cu două semnale scurte",
                "c) Nava care ajunge din urmă emite două semnale fonice lungi şi două semnale fonice scurte. Nava ajunsă din urmă emite un semnal fonic. Nava care ajunge din urmă răspunde cu un semnal scurt"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "411. Ce obligaţiuni au navele care aud semnale fonice emise de o navă ce iese dintr-un bazin portuar sau dintr-un afluent ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Pe cât posibil să-şi modifice drumul şi viteza lor, astfel încât să ajute ca manevra să se execute în bune condiţii",
                "b) Nu au nici o obligaţie",
                "c) Nu se prevede expres în Regulamentul de Navigaţie pe Dunăre"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "412. La ce distanţă trebuie să se ţină de alte nave un bac ce navigă liber în timpul traversării ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) La circa 1 km",
                "b) Nu poate părăsi locul de acostare dacă sunt nave în marş în amonte sau în aval",
                "c) La o distanţă astfel ca celelalte nave să nu fie obligate de a se îndepărta din drumul lor sau să reducă viteza pentru a evita un abordaj"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "413. Ce semnalizare suplimentară vor purta navele care au prioritate de trecere ziua în marş ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O flamură roşie ridicată la prova la o înălţime suficientă ca să fie bine vizibilă",
                "b) La apropierea de alte nave se va agita o flamură roşie la prova",
                "c) O flamură albă la prova la o înălţime suficientă ca să fie bine vizibilă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "414. Ce semnificaţie au semnalele de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-103.jpg",
            "answers": [
                "a) Interzice ancorarea",
                "b) Interzice ancorarea şi de a lăsa să se târască ancore, parâme şi lanţuri pe partea căii unde este amplasat",
                "c) Interzice ancorarea şi de a se lăsa să se târască ancore în zona ambelor maluri"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "415. Amonte pe calea navigabilă este sensul :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Spre izvor",
                "b) Spre revărsare",
                "c) De la un mal la celălalt"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "416. Ce navă oferă prima drumul în caz de întâlnire ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava care navigă aval",
                "b) În funcţie de împrejurările locale şi de mişcările celorlalte nave, nava care vede prima",
                "c) Nava care navigă amonte"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "417. În cazul când vizibilitatea este redusă navele înainte de a se angaja într-o trecere îngustă trebuie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să emită un sunet lung",
                "b) Să nu se angajeze în trecerea îngustă",
                "c) Să emită numai semnale de vizibilitate redusă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "418. Care sunt semnalele fonice emise în cazul unei depăşiri prin babord atât de nava care ajunge din urmă, cât şi de nava ajunsă care nu poate oferi drumul cerut, însă poate oferi depăşirea prin partea opusă :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava care ajunge din urmă emite două sunete lungi şi două sunete scurte, nava ajunsă emite două sunete scurte",
                "b) Nava care ajunge din urmă emite două sunete scurte. Nava ajunsă emite un sunet scurt",
                "c) Nava care ajunge din urmă emite două sunete lungi şi un sunet scurt. Nava ajunsă emite un sunet scurt"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "419. Este interzis a se angaja cu o navă în intervalele dintre unităţile unui convoi remorcat ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Nu este prevăzut în Regulament"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "420. Ce putere trebuie să aibă împingătorul unui convoi ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Conform celor stabilite de Registrul Naval Român",
                "b) O putere astfel încât să poată opri în timp util convoiul fără a întoarce manevrabilitatea rămânând bună",
                "c) O putere suficientă pentru a putea opri convoiul în circa 200 m, asigurându-i o bună manevrabilitate"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "421. Unde este interzis de a se instala plase sau alte unelte de pescuit ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) În canale navigabile",
                "b) În locurile de ancoraj",
                "c) În şenalul navigabil"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "422. Navele cu aripi portante de orice dimensiuni sunt obligate :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bis Să nu jeneze mişcările şi manevrele celorlalte nave",
                "b) Să traverseze calea navigabilă numai în porturi",
                "c) Să facă înscrucişările cu alte nave numai prin tribord"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "423. În cazul întâlnirii dintre două nave prin babord, în condiţii normale, este obligatorie emiterea de semnale fonice ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Nu este prevăzut expres în Regulamentul de Navigaţie pe Dunăre"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "424. Când este permisă depăşirea între nave ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Când aceasta se face prin tribord",
                "b) Când nava care ajunge din urmă s-a asigurat că această manevră poate să aibă loc fără pericol",
                "c) Când aceasta se face prin babord"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "425. Cum se procedează în cazul depăşirii dintre o navă trasă la edec şi o navă autopropulsată, care nu este trasă la edec ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava autopropulsată, care vrea să depăşească nava trasă la edec, cere, prin semnale fonice, depăşirea prin tribord sau babord, iar nava trasă la edec, oferă depăşirea prin semnale fonice la babord sau la tribord",
                "b) Nava trasă la edec trebuie să se oprească imediat ce aude semnalele de depăşire ale navei autopropulsate",
                "c) Nava care nu este trasă la edec trebuie, întotdeauna să lase navei trase la edec, partea de halaj navei trasă la edec"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "426. Când nu se aplică interdicţia de a se lăsa să se târască ancore, parâme sau lanţuri ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) În cazul micilor mişcări la locurile de staţionare sau în cazul manevrelor",
                "b) Întotdeauna, în sectoarele unde este permisă ancorarea",
                "c) Când şenalul are o lăţime absolut suficientă, iar adâncimile trec de 6 m"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "427. Se pot utiliza căngile de fier în ecluze ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu este prevăzut în Regulamentul de Navigaţie pe Dunăre",
                "b) Da",
                "c) Nu"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "428. Două convoaie prin împingere se întâlnesc într-o zonă unde trebuie emise semnale sonore de întâlnire. În această situaţie primul semnal fonic este emis :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) De convoiul care navigă aval",
                "b) De convoiul care navigă amonte",
                "c) De convoiul care-l vede primul pe celălalt"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "429. Încrucişarea sau depăşirea sunt permise atunci când :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Întreaga semnalizare optică şi fonică a navelor ce se încrucişează sau se depăşesc este în perfectă stare de funcţionare",
                "b) Şenalul are lăţime absolut suficientă pentru trecerea simultană ţinând cont de toate împrejurările locale şi de mişcările altor nave",
                "c) Instalaţiile de ancorare şi guvernare nu sunt defecte"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "430. În cazul întâlnirii între o navă trasă la edec şi o navă care nu este trasă la edec, aceasta din urmă are obligaţia :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să se oprească imediat ce vede nava trasă la edec",
                "b) Nu are nici o obligaţie",
                "c) Să lase partea de halaj navei trase la edec"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "431. Care sunt semnalele fonice emise, în cazul unei depăşiri prin babord, atât de nava care ajunge din urmă, cât şi de nava ajunsă :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava care ajunge din urmă emite “un sunet lung” şi “două sunete scurte”, nava ajunsă din urmă emite “un sunet scurt”",
                "b) Nava care ajunge din urmă emite “două sunete lungi” şi “un sunet scurt”, nava ajunsă din urmă emite, “două sunete scurte”",
                "c) Nava care ajunge din urma emite “două sunete lungi” şi ‘două sunete scurte”, nava ajunsă din urmă emite, “ un sunet scurt”"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "432. Navele care părăsesc locul lor de ancorare sau de acostare fără a întoarce sau care traversează calea navigabilă, cu excepţia bacurilor, iar în raza de vizibilitate nu sunt alte nave, au obligaţia de a emite vreun semnal fonic ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Nu se prevede expres în Regulamentul de Navigaţie pe Dunăre"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "433. Au dreptul de a folosi semnalul de zi sau de noapte pentru protejare împotriva valurilor :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Navele avariate grav, navele care participă la operaţiuni de salvare, navele eşuate, scufundate sau în imposibilitate de manevră, navele care au o autorizaţie scrisă dată de căpităniile de port",
                "b) Toate navele pot arbora semnalul respectiv",
                "c) Numai cele care sunt autorizate de căpităniile de port"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "434. De când şi până când se emit semnalele sonore de vizibilitate redusă de către navele staţionate în şenal sau în apropierea acestuia în afara porturilor şi a locurilor afectate special pentru staţionare ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Imediat ce vizibilitatea s-a redus şi până când vizibilitatea devine bună la intervale de cel mult două minute",
                "b) Tot timpul cât persistă vizibilitatea redusă, la intervale de cel mult 1 minut",
                "c) Imediat şi tot timpul când percep semnale sonore ale unor nave ce se apropie de zona respectivă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "435. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-104.jpg",
            "answers": [
                "a) Interzicerea de a depăşi viteza indicată în raport cu malurile",
                "b) Interzicerea staţionării pe lăţimea indicată în metri (măsurată de la semnal)",
                "c) Interzicerea staţionării pe lungimea indicată în metri"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "436. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-105.jpg",
            "answers": [
                "a) Permiterea de a staţiona pe o lăţime a suprafetei apei, măsurată de la semnal şi indicată în metri pe acesta",
                "b) Indicaţia de a păstra distanţa faţă de malul unde este amplasat semnalul",
                "c) Lăţimea minimă a locurilor de staţionare în metri"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "437. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-106.jpg",
            "answers": [
                "a) Numărul maxim de nave permise a staţiona bord la bord",
                "b) Lungimea maximă a locurilor de staţionare stabilite în număr de dane",
                "c) Recomandarea de a naviga cu numărul de unităţi în dana indicată"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "438. Ce semnificaţie are semnalul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-107.jpg",
            "answers": [
                "a) Autorizaţia de a staţiona a navelor cu echipaj cu excepţia navelor care trebuie să poarte ziua conul albastru sau roşu",
                "b) Autorizaţia de staţionare a navelor cu echipaj cu excepţia navelor care trebuie să poarte ziua conul albastru",
                "c) Zona de staţionare rezervată navelor fără echipaj cu excepţia navelor care trebuie să poarte ziua conul albastru sau roşu"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "439. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-108.jpg",
            "answers": [
                "a) Autorizaţia de staţionare a navelor cu echipaj care trebuie să poarte ziua conul albastru",
                "b) Autorizaţia de staţionare a navelor cu echipaj cu excepţia navelor care trebuie să poarte ziua conul albastru",
                "c) Zona de staţionare rezervată navelor fără echipaj care trebuie să poarte ziua conul albastru"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "440. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-109.jpg",
            "answers": [
                "a) Autorizaţia de staţionare a navelor cu echipaj care trebuie să poarte ziua conul roşu",
                "b) Zona de staţionare rezervată navelor fără echipaj care trebuie să poarte ziua conul roşu",
                "c) Autorizaţia de staţionare a navelor fără echipaj care trebuie să poarte ziua conul roşu"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "441. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-110.jpg",
            "answers": [
                "a) Autorizaţia de staţionare a navelor fără echipaj cu excepţia navelor care trebuie să poarte ziua conul albastru sau roşu",
                "b) Zona de staţionare rezervată navelor cu echipaj cu excepţia navelor care trebuie să poarte ziua conul albastru sau roşu",
                "c) Autorizaţia de staţionare a navelor cu echipaj care trebuie să poarte ziua conul albastru"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "442. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-111.jpg",
            "answers": [
                "a) Autorizaţia de staţionare a navelor, fără echipaj care trebuie să poarte ziua conul albastru",
                "b) Zona de staţionare rezervată navelor cu echipaj care trebuie să poarte ziua conul albastru",
                "c) Autorizaţia de staţionare a navelor cu echipaj care trebuie să poarte ziua conul albastru"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "443. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-112.jpg",
            "answers": [
                "a) Autorizaţia de staţionare a navelor fără echipaj care trebuie să poarte ziua conul roşu",
                "b) Autorizaţia de staţionare a navelor cu echipaj cu excepţia navelor care trebuie să poarte ziua conul roşu",
                "c) Zona de staţionare rezervată navelor cu echipaj care trebuie să poarte ziua conul roşu"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "444. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-113.jpg",
            "answers": [
                "a) Zona de staţionare rezervată navelor cu şi fără echipaj cu excepţia navelor care trebuie să poarte ziua conul albastru sau roşu",
                "b) Autorizaţia de staţionare a navelor cu echipaj sau fără echipaj",
                "c) Autorizaţia de staţionare a navelor cu echipaj şi fără echipaj care trebuie să poarte ziua conul albastru sau roşu"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "445. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-114.jpg",
            "answers": [
                "a) Zona de staţionare rezervată navelor cu şi fără echipaj care trebuie să poarte ziua conul albastru",
                "b) Autorizaţia de staţionare a navelor cu echipaj şi fără echipaj, cu excepţia navelor care trebuie să poarte ziua conul albastru",
                "c) Autorizaţia de staţionare a navelor cu echipaj şi fără echipaj care transportă materiale explozibile"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "446. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-115.jpg",
            "answers": [
                "a) Autorizaţia de staţionare a navelor cu echipaj şi fără echipaj cu excepţia navelor care trebuie să poarte ziua conul roşu",
                "b) Zona de staţionare rezervată navelor cu echipaj şi fără echipaj care trebuie să poarte ziua conul roşu",
                "c) Autorizaţia de staţionare a navelor cu echipaj şi fără echipaj care transportă materiale inflamabile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "447. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-116.jpg",
            "answers": [
                "a) Interzicerea de a intra în bazin care este situat în direcţia săgeţii",
                "b) Interzicerea prelungită de intrare în bazin. Navele care doresc să intre trebuie să se informeze",
                "c) Interzicerea temporară de ieşire din bazin. Navele care doresc să iasă din bazin trebuie să aştepte într-un loc potrivit în aşa fel încât să nu jeneze mişcarea navelor care intră"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "448. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-117.jpg",
            "answers": [
                "a) Permitere de intrare în bazin care este situat în direcţia săgeţii",
                "b) Permiterea ieşirii din bazin",
                "c) Permiterea navelor care doresc să iasă din bazin de a înainta până în zona de ieşire din bazin"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "449. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-118.jpg",
            "answers": [
                "a) Obligaţia de a intra în legătura radiotelefonică pe canalul indicat, pe panou",
                "b) Obligaţia de a lua legătura pe lungimea de undă indicată",
                "c) Interzicerea de a folosi canalul indicat"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "450. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-119.jpg",
            "answers": [
                "a) Permiterea de a lăsa la apă sau de a ridica pe mal ambarcaţiuni",
                "b) Interzicerea de a lăsa la apă ambarcaţiuni",
                "c) Interzicerea de a lăsa la apă sau de aridica pe mal ambarcaţiuni cu lungimea mai mare de 15 m"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "451. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-120.jpg",
            "answers": [
                "a) Permiterea navigaţiei cu scândura cu velă",
                "b) Interzicerea schiului nautic",
                "c) Obligaţia de a folosi scândura cu velă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "452. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-121.jpg",
            "answers": [
                "a) Interzicerea ieşirii din bazin, care este situat în direcţia săgeţii",
                "b) Interzicerea prelungită de ieşire din bazin. Navele care doresc să iasă trebui să se informeze",
                "c) Interzicerea temporară de ieşire din bazin. Navele care doresc să iasă din bazin trebuie să aştepte în locurile desemnate în acest scop"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "453. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-122.jpg",
            "answers": [
                "a) Permiterea de ieşire din bazin, care este situat în direcţia săgeţii",
                "b) Permiterea intrării din bazin",
                "c) Permiterea navelor care ies din bazin să înainteze până la acest semnal"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "454. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-123.jpg",
            "answers": [
                "a) Zona permisă pentru navigaţia cu viteză mare a ambarcaţiunilor mici de sport sau de agrement",
                "b) Zona interzisă pentru navigaţia cu viteză mare a ambarcaţiunilor mici de sport şi agrement",
                "c) Zona permisă pentru navigaţia cu viteză mare tuturor navelor"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "455. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-124.jpg",
            "answers": [
                "a) Zona de staţionare rezervată pentru încărcarea şi descărcarea vehiculelor (durata maximă a staţionării permise poate fi indicată pe o tăbliţă indicată sub panou)",
                "b) Zona rezervată încărcării vehiculelor",
                "c) Zona rezervată descărcării vehiculelor"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "456. Ce semnificaţie are semnalul de mai jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-125.jpg",
            "answers": [
                "a) Bac care navigă liber",
                "b) Bac care navigă pe cablu",
                "c) Doc pentru staţionarea bacurilor care nu navigă liber"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "457. Geamnadura din figura de mai jos marchază :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-126.jpg",
            "answers": [
                "a) Limitele şenalului şi direcţia sa; ea balizează partea dreaptă a şenalului, şi pericolele de la malul drept",
                "b) Joncţiunea şi bifurcaţia şenalului; ea balizează pericolele de navigaţie din şenal",
                "c) Locul de staţionare în raport cu limita dreaptă a şenalului"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "458. Geamnadura din figura de jos marchează :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-127.jpg",
            "answers": [
                "a) Limitele şenalului şi direcţia sa; ea balizează partea stângă a şenalului şi pericolele de la malul stâng",
                "b) Axa şenalului",
                "c) Locurile de staţionare în raport cu limita stânga a şenalului"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "459. Ce distanţă minimă trebuie să se respecte între nave, în staţionare, dacă una din ele transportă materiale inflamabile ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 10 m",
                "b) 8 m",
                "c) 6 m"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "460. Lichidele combustibile miscibile cu apă în orice proporţie sunt considerate ca transport de materiale inflamabile ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu este prevăzut în Regulamentul de Navigaţie pe Dunăre",
                "b) Nu",
                "c) Da"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "461. Combustibilii care servesc motoarelor principale şi auxiliare ale navei, dacă combustibilul este închis în rezervoare speciale destinate acestui scop, este considerat transport de materiale inflamabile ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Nu este prevăzut în Regulamentul de Navigaţie pe Dunăre"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S4",
            "difficulty": 1
        },
        {
            "question": "462. Unde este interzisă întâlnirea şi depăşirea navelor pe canalul Sulina ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Pe toată lungimea canalului",
                "b) În porturi şi prin faţa semnafoarelor",
                "c) La coturi şi în locurile unde şenalul nu oferă lăţime suficientă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "463. Care este numărul maxim al şlepurilor admise la remorcă pe canalul Sulina şi care este dispunerea lor la navigaţia în aval ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Patru şlepuri câte două în dană",
                "b) Două şlepuri într-o singură dană",
                "c) Un singur şlep"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "464. De unde şi până unde sunt obligate navele maritime, în timpul navigaţiei să aibă la bord un pilot autorizat ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Din rada Sulina până la portul Brăila",
                "b) De la gura canalului Sulina până în portul Brăila",
                "c) De la Mm 0 până la km 176"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "465. Câte şlepuri sunt admise într-un convoi remorcat, ce iese din canalul Sulina în mare ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Maximum 4 în două dane a câte două unităţi",
                "b) Maximum două",
                "c) Un şlep"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "466. Care este distanţa minimă permisă la apropierea unei nave de alta, la trecerea punctelor dificile sau a coturilor pronunţate în canalul Sulina ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 0,5 Mm",
                "b) 1 Mm",
                "c) 1,5 Mm"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "467. Pe sectorul maritim al Dunării de Jos şi la bara Sulina, navele maritime sunt obligate a respecta pescajul maxim în apa dulce de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 7,00 m",
                "b) 6,98 m",
                "c) 7,01 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "468. Care sunt obligaţiile navelor maritime care depăşesc 75 m lungime, la trecerea prin bara Sulina, canalul Sulina şi punctele dificile de pe sectorul maritim al Dunării de Jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Staţia radio să fie în permanenţă în funcţiune",
                "b) Să aibă la pupa o ancoră pregătită în orice moment pentru a fi utilizată",
                "c) Să fie pregătite toate bărcile de salvare pentru a fi lansate la apă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "469. Piloţii administraţiei sau autorizaţi de aceasta vor exercita pilotajul navelor maritime şi fluvio-maritime în sectorul :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) De la gura canalului Sulina până în portul Brăila",
                "b) Din rada Sulina până în portul Brăila",
                "c) Din portul Sulina până în portul Brăila"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "470. Care este distanţa minimă permisă oricărei nave sau mici ambarcaţiuni, la traversarea canalului Sulina, prin prova navelor maritime aflate în marş ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O milă marină",
                "b) 2 mile marine",
                "c) 0,5 mile marine"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "471. Care este lungimea maximă a remorcii unui convoi care iese din canalul Sulina în mare :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 100 m",
                "b) 30 m",
                "c) 50 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "472. Căror nave le este interzisă navigaţia pe canalul Sulina ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Navele cu o lungime mai mică de 123 m",
                "b) Navele ce navigă cu vele, cu un tonaj mai mare de 50 t",
                "c) Navelor cu un pescaj mai mic de 6,50 m"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "473. La întâlnirea unei nave fluviale cu o navă maritimă pe sectorul maritim al Dunării de Jos, care navă se abate din drum, pentru a lăsa drum liber celeilalte nave ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava fluvială",
                "b) Nava maritimă",
                "c) Nava care navigă amonte"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "474. Regulile speciale de navigaţie pe Dunărea de jos se aplică tuturor navelor maritime şi fluviale ce navigă în sectorul :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) De la rada Sulina până la Km 175",
                "b) De la Mm 0 până la km 171",
                "c) De la Mm 0 până la km 175"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "475. Ce nave pot fi depăşite la navigaţia în aval pe canalul Sulina cu excepţia locurilor interzise ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Navele până la 4000 t deplasament",
                "b) Navele până la 3200 t deplasament",
                "c) Navele de orice deplasament"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "476. Câte şlepuri sunt admise într-un convoi remorcat, ce intră din mare în canalul Sulina ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Maxim 4, în 2 dane a câte 2 unităţi",
                "b) Maximum 2",
                "c) Maximum 1"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "477. Care este viteza maximă admisă a bacurilor motor de 20 t pe braţul Tulcea şi canalul Sulina în marş aval ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 4 Nd",
                "b) 6 Nd",
                "c) 8 Nd"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "478. Ce semnalizare de noapte poartă navele maritime ce navigă pe Dunărea Maritimă ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Semnalele prevăzute în Regulamentul de navigaţie pe Dunăre",
                "b) Semnalele prevăzute în Regulamentul internaţional de prevenire a abordajului pe mare",
                "c) Semnalele stabilite de A.F.D.J."
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "479. La apropierea simultană a două nave de sectoarele dificile de trecere ale canalului Sulina şi pe Dunărea de Jos, prioritatea de trecere o are :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) La înţelegere prin semnale sonore",
                "b) Nava care navigă amonte",
                "c) Nava care navigă aval"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "480. Care este lungimea maximă a remorcii unui convoi care intră din mare în canalul Sulina :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 100 m",
                "b) 30 m",
                "c) 50 m"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "481. Ce nave pot fi depăşite la navigaţia în amonte pe canalul Sulina cu excepţia locurilor interzise ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Navele până la 4000 t",
                "b) Navele până la 5000 t",
                "c) Navele de orice tonaj"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "482. Care este lungimea maximă a remorci admisă pe canalul Sulina ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 40 m",
                "b) 30 m",
                "c) 35 m"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "483. Cine poartă răspunderea privind marşul şi manevrele executate de o navă maritimă, ce navigă pe Dunărea Maritimă ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Comandantul navei",
                "b) Pilotul de Dunăre maritimă îmbarcat la bordul navei",
                "c) Comandantul navei şi pilotul de Dunăre maritimă îmbarcat la bordul navei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "484. Care este înclinarea maximă admisă, navelor ce navigă în sectorul maritim al Dunării de Jos ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 5 grade",
                "b) 7 grade",
                "c) 4 grade"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "485. Care sunt dimensiunile maxime ale materialelor plutitoare asamblate remorcate pe canalul Sulina ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Lungimea 45 m, lăţimea 12 m",
                "b) Lungimea 30 m, lăţimea 15 m",
                "c) Lungimea 40 m, lăţimea 16 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "486. Care este viteza maximă admisă navelor de pasageri, tip “MUNTENIA”, pe canalul Sulina, în marş amonte ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 9 Nd",
                "b) 10 Nd",
                "c) 12 Nd"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "487. Care este numărul maxim admis al şlepurilor remorcate pe canalul Sulina şi care este dispunerea lor la navigaţia în amonte ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 4 şlepuri, câte două în dană",
                "b) 2 şlepuri într-o singură dană",
                "c) Nu este admis remorcajul pe canalul Sulina"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "488. Care este viteza maximă admisă a navelor hidrobuz tip Flamingo pe canalul Sulina în marş aval ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 8 Nd",
                "b) 7 Nd",
                "c) 10 Nd"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "489. Care este viteza maximă admisă pe canalul Sulina a navelor maritime de 5000 tdw în marş aval ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 6 Nd",
                "b) 9 Nd",
                "c) 8 Nd"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "490. Ce lungime trebuie să depăşească navele maritime la trecerea prin portul Tulcea pentru a primi în mod obligatoriu asistenţă sau remorcaj din partea unui remorcher ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 185 m",
                "b) 150 m",
                "c) 120 m"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "491. Care este viteza maximă admisă şalupelor tip 65 CP pe canalul Sulina în marş aval ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 6 Nd",
                "b) 9 Nd",
                "c) 8 Nd"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "492. Care este viteza maximă admisă pe canalul Sulina a navelor maritime de 25000 tdw în marş aval ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu este prevăzut în Regulamentul de Navigaţie pe Dunăre",
                "b) 5 Nd",
                "c) 7 Nd"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "493. Navele remorcher ce navigă aval fără convoi pe canalul Sulina vor merge cu viteza :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 9 Nd",
                "b) 5 Nd",
                "c) Până la limita producerii valurilor"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "494. Care este viteza maximă admisă a navelor de pasageri tip Malnaş pe canalul Sulina în marş aval ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 10 Nd",
                "b) 8 Nd",
                "c) 9 Nd"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "495. Ce semnificaţie are semnalul alăturat arborat la staţiile semaforice de pe Dunărea Maritimă ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-128.jpg",
            "answers": [
                "a) Fiţi atenţi la semnalele mele",
                "b) Vizibilitatea redusă pe canalul Sulina",
                "c) Vreau să comunic cu dumneavoastră"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "496. Care este viteza maximă admisă navelor maritime până la 1500 tdw pe canalul Sulina în marş aval ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 8 Nd",
                "b) 9 Nd",
                "c) 10 Nd"
            ],
            "correctAnswer": [
                2
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "497. Ce semnificaţie are pavilionul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-129.jpg",
            "answers": [
                "a) Solicit pilot la bord",
                "b) Sunt în imposibilitate de guvernare",
                "c) Solicit asistenţă din partea dumneavoastră"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "498. Care este viteza maximă admisă a navelor maritime între 12000 şi 25000 tdw pe canalul Sulina în marş aval ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 7 Nd",
                "b) 8 Nd",
                "c) 9 Nd"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "499. Ce semnificaţie are pavilionul din imaginea alăturată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-130.jpg",
            "answers": [
                "a) Am pilot la bord",
                "b) Solicit pilot la bord",
                "c) Solicit asistenţă medicală la bord"
            ],
            "correctAnswer": [
                1
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "500. Ce semnificaţie are flamura de mai jos arborată la catargul staţiei semaforice Ceatal Ismail ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "questionPic": "images/imaginiRND-131.jpg",
            "answers": [
                "a) Interzicerea temporară a navigaţiei pe braţul Chilia",
                "b) Vizibilitate redusă pe braţul Tulcea şi canalul Sulina",
                "c) Curent puternic pe canalul Sulina"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S5",
            "difficulty": 1
        },
        {
            "question": "501. Ce semnificaţie are un pavilion roşu arborat la catargul din prova unei nave aflate în marş ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nava izolată în marş ce transportă materiale explozibile",
                "b) Nave care transportă materiale inflamabile ale căror tancuri nu au fost degazate",
                "c) Nava are prioritate de trecere în locurile în care trecerea este reglementată de autorităţile competente"
            ],
            "correctAnswer": [
                3
            ],
            "section": "RND-S5",
            "difficulty": 1
        }
    ]
};
